<template>
  <f7-page name="control-cifras-oeb-prod-plan" @page:init="onPageInit" @page:beforeremove="cancelarEsperaMaxima" @click.native="tooltipToggle = null; tooltipKpiData = null">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Productividad Planificaci&oacute;n</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) cargarInstrucciones()" style="margin-right:4px">
          <span style="background:linear-gradient(135deg,#0F6E56,#27ae80);color:#fff;border-radius:50%;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;font-size:13px;font-weight:700">i</span>
        </f7-link>
        <f7-button small fill color="green" @click="guardarConfig" :disabled="guardando" style="margin-right:8px;font-size:10px">Guardar</f7-button>
        <f7-button small fill color="blue" @click="recalcular" :disabled="recalculando" style="margin-right:8px;font-size:10px" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">{{ recalculando ? 'Calculando...' : 'Recalcular' }}</f7-button>
        <f7-button small fill style="background:#198754;margin-right:8px;font-size:10px" @click="crearMesSiguiente" :disabled="creandoMes" v-roles="['ADMIN','DIRECTOR','DTYCAL']">{{ creandoMes ? 'Creando...' : '+ ' + getNombreMesSiguiente() }}</f7-button>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">&minus;</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="cargarDatos" title="Actualizar"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · La pantalla se sirve de oeb_productividad_plan_cache; "Recalcular" reescribe su -->
    <!-- calculadoEn. Sustituye al antiguo "Cache: ...", que solo salia si habia fecha. -->
    <div class="sello-datos-bar">
      <sello-datos estado="fecha" :fecha="datos && datos.calculadoEn" />
    </div>

    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="contenido-pp" :style="{ fontSize: (zoom * 0.12) + 'px' }">

        <!-- SELECTOR MES/A&Ntilde;O -->
        <div class="mes-selector">
          <f7-link @click="mesPrevio" icon-f7="chevron_left"></f7-link>
          <select v-model.number="anio" @change="cargarDatos" class="sel-anio">
            <option v-for="a in aniosDisponibles" :key="a" :value="a">{{ a }}</option>
          </select>
          <select v-model.number="mes" @change="cargarDatos" class="sel-mes">
            <option v-for="(n, i) in nombresMeses" :key="i" :value="i + 1">{{ n }}</option>
          </select>
          <f7-link @click="mesSiguiente" icon-f7="chevron_right"></f7-link>
          <span v-if="datos && !objetivoFiable" style="background:#DC3545;color:#fff;border-radius:3px;padding:2px 6px;font-size:9px;font-weight:700;margin-left:10px" title="No se ha podido calcular el objetivo del mes. Lo confirmado es correcto; el objetivo y el cumplimiento vuelven al recargar en cuanto el c&aacute;lculo funcione.">OBJ. NO DISPONIBLE</span>
          <span v-if="datos" style="display:inline-flex;gap:6px;margin-left:auto">
            <span style="background:#0d6efd;color:#fff;padding:3px 10px;border-radius:4px;font-size:10px;font-weight:600;cursor:pointer" @click="abrirPopupReporte" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Enviar reporte</span>
            <span style="background:#f0f2f5;color:#666;padding:3px 10px;border-radius:4px;font-size:10px;font-weight:600;cursor:pointer;border:1px solid #ddd" @click="$f7router.navigate('/dashboard/oeb/notificaciones-prodplan/')" v-roles="['ADMIN','DIRECTOR','DTYCAL']">Programar env&iacute;os</span>
          </span>
        </div>

        <!-- KPIs FILA 1 -->
        <div class="kpi-grid" v-if="datos">
          <div class="kpi-card kpi-dark">
            <div class="kpi-label">OEB mes <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'OEB mes', 'Objetivo Econ\u00f3mico Bruto del mes. Viene de Control de Cifras OEB Planificaci\u00f3n (oeb_fichas_mensuales).')">i</span></div>
            <div class="kpi-val">{{ oebDisponible ? fmtNum(datos.oebMes) : 'n/d' }}</div>
          </div>
          <div class="kpi-card kpi-blue">
            <div class="kpi-label">Obj. planif. ({{ Math.round((datos.porcentajePlanificacion || 0.8) * 100) }}%) <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Obj. planificaci\u00f3n', 'Objetivo de planificaci\u00f3n = OEB MES \u00d7 porcentaje planificaci\u00f3n. El porcentaje se configura por mes.')">i</span></div>
            <div class="kpi-val">{{ fmtObj(datos.objetivoTotal) }}</div>
          </div>
          <div class="kpi-card kpi-green">
            <div class="kpi-label">Confirmado <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Confirmado', 'Total confirmado en el mes (fechaConfirmacionPlanificacion). Suma de importeReparto de reparto-ejec-lineas-pedidos + T0004 complementarias.')">i</span></div>
            <div class="kpi-val">{{ fmtNum(totalPlanificado) }}</div>
          </div>
          <div class="kpi-card" :class="!objetivoFiable ? 'kpi-grey' : pctCumplimiento >= 100 ? 'kpi-green' : pctCumplimiento >= 80 ? 'kpi-yellow' : 'kpi-red'">
            <div class="kpi-label">% Cumplimiento <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, '% Cumplimiento', 'Porcentaje de cumplimiento = CONFIRMADO / OBJ. PLANIF. \u00d7 100.')">i</span></div>
            <div class="kpi-val">{{ fmtPctObj(pctCumplimiento) }}</div>
          </div>
          <div class="kpi-card" :class="!objetivoFiable ? 'kpi-grey' : faltaTotal > 0 ? 'kpi-red' : 'kpi-green'">
            <div class="kpi-label">Falta <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Falta', 'Importe que falta para cumplir el objetivo = OBJ. PLANIF. - CONFIRMADO.')">i</span></div>
            <div class="kpi-val">{{ fmtObj(faltaTotal) }}</div>
          </div>
          <div class="kpi-card" :class="objetivoFiable ? 'kpi-blue' : 'kpi-grey'">
            <div class="kpi-label">Falta/d&iacute;a <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Falta/d\u00eda', 'Importe que falta por d\u00eda restante = FALTA / d\u00edas h\u00e1biles restantes del mes.')">i</span></div>
            <div class="kpi-val">{{ fmtObj(faltaPorDia) }}</div>
          </div>
        </div>

        <!-- KPIs FILA 2 -->
        <div class="kpi-grid" v-if="datos" style="margin-top:0">
          <div class="kpi-card kpi-grey">
            <div class="kpi-label">N&ordm; planif. <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'N\u00ba planificadores', 'N\u00famero de planificadores activos en el mes.')">i</span></div>
            <div class="kpi-val">{{ personasFiltradas.length }}</div>
          </div>
          <div class="kpi-card kpi-grey">
            <div class="kpi-label">D&iacute;as h&aacute;biles <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'D\u00edas h\u00e1biles', 'D\u00edas laborables del mes (lunes a viernes).')">i</span></div>
            <div class="kpi-val">{{ datos.diasHabiles }}</div>
          </div>
          <div class="kpi-card kpi-grey">
            <div class="kpi-label">D&iacute;as transc. <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'D\u00edas transcurridos', 'D\u00edas h\u00e1biles transcurridos hasta hoy.')">i</span></div>
            <div class="kpi-val">{{ datos.diasTranscurridos }}</div>
          </div>
          <div class="kpi-card kpi-grey">
            <div class="kpi-label">D.R (media) <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'D\u00edas reales (media)', 'Media de d\u00edas reales de los planificadores. D\u00edas reales = d\u00edas h\u00e1biles - vacaciones - bajas - fiestas.')">i</span></div>
            <div class="kpi-val">{{ diasRealesMedia }}</div>
          </div>
          <div class="kpi-card kpi-editable">
            <div class="kpi-label">H. planif. <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Horas planificaci\u00f3n', 'Horas de planificaci\u00f3n por d\u00eda. Editable. Se usa para calcular PLAN/HORA y PLAN/H.')">i</span></div>
            <div class="kpi-val"><input type="number" class="kpi-input-edit" v-model.number="configLocal.horasPlanificacion" step="0.5"></div>
          </div>
          <div class="kpi-card kpi-blue">
            <div class="kpi-label">Plan/hora <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Plan/hora', 'Confirmado por hora real = CONFIRMADO / (suma d\u00edas reales \u00d7 horas planificaci\u00f3n).')">i</span></div>
            <div class="kpi-val">{{ planPorHora }}</div>
          </div>
          <div class="kpi-card kpi-dark">
            <div class="kpi-label" style="font-size:8px">Prod.med. d&iacute;a/pers <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, 'Prod. media d\u00eda/persona', 'Productividad media diaria por persona = CONFIRMADO / suma de d\u00edas reales de todos los planificadores.')">i</span></div>
            <div class="kpi-val">{{ fmtNum(prodMedia) }}</div>
          </div>
        </div>

        <!-- TOGGLES -->
        <div class="toggles-pp" v-if="datos">
          <div v-for="td in togglesDef" :key="td.clave" class="t-btn" :style="tStyle(td.color, toggles[td.clave])" @click="toggles[td.clave] = !toggles[td.clave]" style="display:inline-flex;align-items:center;gap:3px">
            <span>{{ td.nombre }}</span>
            <span @click.stop="abrirTooltipToggle($event, td)" class="toggle-info-btn">i</span>
          </div>
          <div class="t-btn" :style="redObjMen ? 'background:#E65100;color:#fff;border:1px solid #E65100' : 'background:#f0f2f5;color:#666;border:1px solid #ddd'" @click="redObjMen = !redObjMen" style="display:inline-flex;align-items:center;gap:3px">
            <span>RED.OBJ.MEN</span>
            <span @click.stop="abrirTooltipToggle($event, redObjMenInfo)" class="toggle-info-btn">i</span>
          </div>
          <div class="t-btn" style="background:#1a2744;color:#fff;border:1px solid #1a2744" @click="mostrarTodas">Mostrar todos</div>
          <span v-if="numOcultas > 0" style="font-size:10px;color:#dc3545;margin-left:2px;align-self:center">({{ numOcultas }} ocultas)</span>
          <!-- R-1: aviso no bloqueante si los % de los planificadores no suman 100 -->
          <span v-if="sumaPorcentajesFueraRango" :title="'Los porcentajes de los planificadores visibles deberían sumar 100% para que la suma de filas cuadre con el total mostrado.'" style="font-size:10px;color:#E65100;background:#FFF3E0;border:1px solid #FFB74D;padding:2px 6px;border-radius:3px;margin-left:6px;align-self:center;font-weight:600">&#9888; % no suman 100% (actual: {{ sumaPorcentajesPct }}%)</span>
        </div>
        <div v-if="tooltipToggle !== null" class="tooltip-overlay" @click="tooltipToggle = null">
          <div class="tooltip-fixed" :style="tooltipTogglePos" @click.stop>
            <div style="font-weight:600;margin-bottom:3px">{{ tooltipToggleData.nombre }}</div>
            {{ tooltipToggleData.desc }}
          </div>
        </div>
        <div v-if="tooltipKpiData" class="tooltip-overlay" @click="tooltipKpiData = null">
          <div class="tooltip-fixed" :style="tooltipKpiPos" @click.stop>
            <div style="font-weight:600;margin-bottom:3px">{{ tooltipKpiData.nombre }}</div>
            {{ tooltipKpiData.desc }}
          </div>
        </div>

        <!-- CARGANDO -->
        <div v-if="cargando" style="text-align:center;padding:40px;color:#999">
          <f7-preloader></f7-preloader>
          <p>Cargando datos...</p>
        </div>

        <!-- NO SE HAN PODIDO CARGAR LOS DATOS -->
        <div v-if="errorCarga && !cargando" style="text-align:center;padding:40px">
          <div style="font-weight:700;color:#DC3545;font-size:14px;margin-bottom:6px">No se han podido cargar los datos del mes</div>
          <div style="color:#7c8db0;font-size:12px;margin-bottom:12px">{{ errorCarga }}</div>
          <f7-button small fill @click="cargarDatos" style="display:inline-block;min-width:120px">Reintentar</f7-button>
        </div>

        <!-- TABLA PLANIFICADORES x SEMANAS (estructura OEB Planificaci&oacute;n) -->
        <div class="tabla-wrap" v-if="datos && datos.semanas && personasFiltradas.length">
          <div class="tabla-scroll">
            <table class="tabla-pp">
              <thead>
                <tr>
                  <th class="col-sticky col-codigo">C&Oacute;D</th>
                  <th class="col-multi col-sep-left" v-for="sem in datos.semanas" :key="'hs-'+sem.semana">
                    S{{ sem.semana }}<br><span class="sem-fechas">{{ sem.primerDia }}-{{ sem.ultimoDia }}</span>
                    <!-- Solo los d&iacute;as de esta semana que caen en el mes: su objetivo es menor por eso. -->
                    <span v-if="sem.parcial" class="sem-parcial" title="Semana partida entre dos meses: aqu&iacute; solo cuentan sus d&iacute;as de este mes">parcial</span>
                  </th>
                  <th class="col-res col-sep-left">PROGR.</th>
                  <th class="col-res">OBJ.</th>
                  <th class="col-res">FALTA</th>
                  <th class="col-pct">%</th>
                  <th class="col-dia col-sep-left">D.H</th>
                  <th class="col-dia">Vac</th>
                  <th class="col-dia">BL</th>
                  <th class="col-dia">Comp</th>
                  <th class="col-dia">D.R</th>
                  <th class="col-dia col-sep-left" v-for="sem in datos.semanas" :key="'hd-'+sem.semana">S{{ sem.semana }}</th>
                  <th class="col-num col-sep-left" style="text-align:center">Obj/<br>d&iacute;a</th>
                  <th class="col-num" style="text-align:center">%Obj</th>
                  <th class="col-num" style="text-align:center">H.D.</th>
                  <th class="col-num" style="text-align:center">Prod/<br>d&iacute;a</th>
                  <th class="col-num" style="text-align:center">Prod/<br>h</th>
                  <th class="col-sem col-sep-left" v-for="sem in datos.semanas" :key="'ho-'+sem.semana">S{{ sem.semana }}</th>
                  <th class="col-num col-sep-left">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(persona, pidx) in personasFiltradas" :key="persona.codigo"
                    :class="pidx % 2 === 1 ? 'fila-alt' : ''" class="fila-persona">
                  <td class="col-sticky col-codigo" :title="persona.nombre || persona.codigo">
                    <span @click.stop="ocultarPersona(persona.codigo)" style="cursor:pointer;color:#dc3545;font-size:8px;margin-right:2px" title="Ocultar en tu vista. Deja de verse tambien en Planificacion Diaria, pero solo para ti: los demas usuarios lo siguen viendo">&#9679;</span>
                    <strong>{{ persona.codigo }}</strong>
                  </td>
                  <!-- Semanas importes (multi-toggle, col-multi como planificaci&oacute;n) -->
                  <td class="col-multi col-sep-left" v-for="sem in datos.semanas" :key="'cs-'+persona.codigo+'-'+sem.semana">
                    <div class="multi-center">
                      <div v-if="toggles.oeb" class="val-line"><span class="vdot" style="background:#1a2744"></span><span>{{ fmtNum(getSemTotal(persona, sem)) }}</span></div>
                      <div v-if="toggles.oebR" class="val-line"><span class="vdot" style="background:#198754"></span><span>{{ fmtNum(getSemTpcSi(persona, sem)) }}</span></div>
                      <div v-if="toggles.oebP" class="val-line"><span class="vdot" style="background:#0d6efd"></span><span>{{ fmtNum(getSemTpcNo(persona, sem)) }}</span></div>
                      <div v-if="toggles.oebPpend" class="val-line"><span class="vdot" style="background:#e6a817"></span><span>{{ fmtNum(getSemPpend(persona, sem)) }}</span></div>
                      <div v-if="toggles.planDia" class="val-line"><span class="vdot" style="background:#E91E63"></span><span>{{ fmtNum(getSemPlanDia(persona, sem)) }}</span></div>
                      <div v-if="toggles.planHSem" class="val-line"><span class="vdot" style="background:#1a2744"></span><span>{{ getSemPlanH(persona, sem) }}</span></div>
                    </div>
                  </td>
                  <!-- Progresi&oacute;n / Objetivo / Falta / % -->
                  <td class="col-res col-sep-left" style="text-align:right"><strong>{{ fmtNum(persona.totalPlan) }}</strong></td>
                  <td class="col-res" style="text-align:right" :title="tituloObjetivoPersona">{{ fmtObj(getObjetivoPersona(persona)) }}</td>
                  <td class="col-res" :class="!objetivoFiable ? '' : sinObjetivoAsignado(persona) ? 'val-warn' : (getFaltaPersona(persona) > 0 ? 'val-neg' : 'val-pos')" :title="objetivoFiable && sinObjetivoAsignado(persona) ? 'Planificador con producción pero sin % asignado en config' : ''" style="text-align:right">{{ fmtObj(getFaltaPersona(persona)) }}</td>
                  <td class="col-pct" style="text-align:center">
                    <span class="badge-pct" :class="objetivoFiable ? pctClase(getPctPersona(persona)) : ''">{{ fmtPctObj(getPctPersona(persona)) }}</span>
                  </td>
                  <!-- Calendario -->
                  <td class="col-dia col-sep-left" style="text-align:center">{{ persona.dh }}</td>
                  <td class="col-dia" :class="{'dia-vac': persona.vac > 0}" style="text-align:center">{{ persona.vac || '' }}</td>
                  <td class="col-dia" :class="{'dia-bl': persona.bl > 0}" style="text-align:center">{{ persona.bl || '' }}</td>
                  <td class="col-dia" :class="{'dia-comp': persona.comp > 0}" style="text-align:center">{{ persona.comp > 0 ? persona.comp : '' }}</td>
                  <td class="col-dia" style="text-align:center">{{ persona.dr }}</td>
                  <!-- D&iacute;as reales por semana -->
                  <td class="col-dia col-sep-left" v-for="sem in datos.semanas" :key="'ds-'+persona.codigo+'-'+sem.semana" style="text-align:center" :class="{'dia-ausencia-sem': getDiasSemPersona(persona, sem) < sem.numDias}">{{ getDiasSemPersona(persona, sem) }}</td>
                  <!-- Productividad -->
                  <td class="col-num col-sep-left" style="text-align:center" :title="redObjMen ? 'Lo que le toca un día normal. Los días en que falta alguien, quien trabaja lleva además su parte: eso se ve día a día en Planificación diaria por persona' : ''" :style="objetivoFiable && hayRedistribucion ? 'color:#E65100;font-weight:700' : ''">{{ fmtObj(getObjDiaBase(persona)) }}</td>
                  <td class="col-num" style="text-align:center"><input type="number" min="0" max="100" step="1" style="width:36px;text-align:center;border:1px solid #ddd;border-radius:3px;padding:1px;font-size:10px" :value="Math.round((persona.porcentaje || 0) * 100)" @change="setPctPersona(persona.codigo, $event.target.value)"></td>
                  <td class="col-num" style="text-align:center"><input type="number" min="0" step="0.5" style="width:36px;text-align:center;border:1px solid #ddd;border-radius:3px;padding:1px;font-size:10px" :value="configLocal.horasPlanificacion" @change="configLocal.horasPlanificacion = parseFloat($event.target.value)"></td>
                  <td class="col-num" style="text-align:center">{{ persona.dr > 0 ? fmtNum(Math.round(persona.totalPlan / persona.dr)) : 0 }}</td>
                  <td class="col-num" style="text-align:center">{{ persona.dr > 0 && configLocal.horasPlanificacion > 0 ? fmtNum(Math.round(persona.totalPlan / persona.dr / configLocal.horasPlanificacion)) : 0 }}</td>
                  <!-- Semanas objetivo -->
                  <td class="col-sem col-sep-left" v-for="sem in datos.semanas" :key="'os-'+persona.codigo+'-'+sem.semana" style="text-align:right;font-size:10px" :style="objetivoFiable && hayRedistribucion ? 'color:#E65100;font-weight:700' : ''">
                    {{ fmtObj(getObjSemPersona(persona, sem)) }}
                  </td>
                  <td class="col-num col-sep-left" style="text-align:right" :title="tituloObjetivoPersona"><strong>{{ fmtObj(getObjetivoPersona(persona)) }}</strong></td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="fila-totales">
                  <td class="col-sticky col-codigo"><strong>TOTAL</strong></td>
                  <td class="col-multi col-sep-left" v-for="sem in datos.semanas" :key="'ts-'+sem.semana">
                    <div class="multi-center">
                      <div v-if="toggles.oeb" class="val-line"><span class="vdot" style="background:#1a2744"></span><strong>{{ fmtNum(getTotalSem(sem)) }}</strong></div>
                      <div v-if="toggles.oebR" class="val-line"><span class="vdot" style="background:#198754"></span><strong>{{ fmtNum(getTotalSemTpcSi(sem)) }}</strong></div>
                      <div v-if="toggles.oebP" class="val-line"><span class="vdot" style="background:#0d6efd"></span><strong>{{ fmtNum(getTotalSemTpcNo(sem)) }}</strong></div>
                      <div v-if="toggles.oebPpend" class="val-line"><span class="vdot" style="background:#e6a817"></span><strong>{{ fmtNum(getTotalSemPpend(sem)) }}</strong></div>
                      <div v-if="toggles.planDia" class="val-line"><span class="vdot" style="background:#E91E63"></span><strong>{{ fmtNum(getTotalSemPlanDia(sem)) }}</strong></div>
                      <div v-if="toggles.planHSem" class="val-line"><span class="vdot" style="background:#1a2744"></span><strong>{{ getTotalSemPlanH(sem) }}</strong></div>
                    </div>
                  </td>
                  <td class="col-res col-sep-left" style="text-align:right"><strong>{{ fmtNum(totalPlanificado) }}</strong></td>
                  <td class="col-res" style="text-align:right"><strong>{{ fmtObj(datos.objetivoTotal) }}</strong></td>
                  <td class="col-res" :class="!objetivoFiable ? '' : faltaTotal > 0 ? 'val-neg' : 'val-pos'" style="text-align:right"><strong>{{ fmtObj(faltaTotal) }}</strong></td>
                  <td class="col-pct" style="text-align:center"><span class="badge-pct" :class="objetivoFiable ? pctClase(pctCumplimiento) : ''">{{ fmtPctObj(pctCumplimiento) }}</span></td>
                  <td class="col-dia col-sep-left" style="text-align:center">{{ getTotalCampo('dh') }}</td>
                  <td class="col-dia" style="text-align:center">{{ getTotalCampo('vac') || '' }}</td>
                  <td class="col-dia" style="text-align:center">{{ getTotalCampo('bl') || '' }}</td>
                  <td class="col-dia" style="text-align:center">{{ getTotalCampo('comp') > 0 ? getTotalCampo('comp') : '' }}</td>
                  <td class="col-dia" style="text-align:center">{{ getTotalCampo('dr') }}</td>
                  <td class="col-dia col-sep-left" v-for="sem in datos.semanas" :key="'td-'+sem.semana"></td>
                  <td class="col-num col-sep-left" style="text-align:center"></td><td class="col-num" style="text-align:center"></td><td class="col-num" style="text-align:center"></td><td class="col-num" style="text-align:center"></td><td class="col-num" style="text-align:center"></td>
                  <td class="col-sem col-sep-left" v-for="sem in datos.semanas" :key="'to-'+sem.semana" style="text-align:right;font-size:10px">
                    <strong>{{ fmtObj(getTotalObjSem(sem)) }}</strong>
                  </td>
                  <td class="col-num col-sep-left" style="text-align:right"><strong>{{ fmtObj(datos.objetivoTotal) }}</strong></td>
                </tr>
                <!-- TOT.OBJ -->
                <tr class="fila-obj">
                  <td class="col-sticky col-codigo"><strong>TOT.OBJ</strong></td>
                  <td class="col-multi col-sep-left" v-for="sem in datos.semanas" :key="'tobj-'+sem.semana" style="text-align:center">
                    <strong>{{ fmtObj(getTotalObjSem(sem)) }}</strong>
                  </td>
                  <td class="col-res col-sep-left"></td><td class="col-res"><strong>{{ fmtObj(datos.objetivoTotal) }}</strong></td>
                  <td class="col-res"></td><td class="col-pct"></td>
                  <td colspan="5" class="col-sep-left"></td>
                  <td class="col-dia col-sep-left" v-for="sem in datos.semanas" :key="'tod-'+sem.semana"></td>
                  <td class="col-sep-left"></td><td></td><td></td><td></td><td></td>
                  <td class="col-sem col-sep-left" v-for="sem in datos.semanas" :key="'too-'+sem.semana"></td>
                  <td class="col-num col-sep-left"></td>
                </tr>
                <!-- % CUMPLIMIENTO POR SEMANA -->
                <tr class="fila-pct">
                  <td class="col-sticky col-codigo"><strong>%</strong></td>
                  <td class="col-multi col-sep-left" v-for="sem in datos.semanas" :key="'tpct-'+sem.semana" style="text-align:center">
                    <span class="badge-pct-sem" :class="objetivoFiable ? getPctSemClass(sem) : ''">{{ fmtPctObj(getPctSem(sem)) }}</span>
                  </td>
                  <td class="col-res col-sep-left"></td><td class="col-res"></td><td class="col-res"></td>
                  <td class="col-pct" style="text-align:center">
                    <span class="badge-pct-sem" :class="objetivoFiable ? getPctSemClass(null) : ''">{{ fmtPctObj(pctCumplimiento) }}</span>
                  </td>
                  <td colspan="5" class="col-sep-left"></td>
                  <td class="col-dia col-sep-left" v-for="sem in datos.semanas" :key="'tpd-'+sem.semana"></td>
                  <td class="col-sep-left"></td><td></td><td></td><td></td><td></td>
                  <td class="col-sem col-sep-left" v-for="sem in datos.semanas" :key="'tpo-'+sem.semana"></td>
                  <td class="col-num col-sep-left"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <!-- PLANIFICACI&Oacute;N DIARIA POR PERSONA -->
        <div v-if="datos && datos.matrizProgresiva && personasFiltradas.length" class="card-comp" style="margin:12px 0 8px 0;border-radius:8px;overflow:hidden">
          <div style="background:#1a2744;color:white;padding:8px 14px;font-size:12px;font-weight:600;display:flex;justify-content:space-between;align-items:center">
            <span>Planificaci&oacute;n diaria por persona <span class="toggle-info-btn" style="margin-left:6px;border-color:rgba(255,255,255,0.4)" @click.stop="abrirTooltipKpi($event, 'Planificaci\u00f3n diaria por persona', 'Tabla de planificaci\u00f3n diaria. Muestra el importe confirmado por cada planificador cada d\u00eda laborable del mes (d\u00eda = d\u00eda de confirmaci\u00f3n). Los colores comparan el importe diario con el objetivo proporcional de cada persona. Filas: planificadores. Columnas: d\u00edas laborables. TOTAL: suma diaria. OBJ/D\u00cdA: objetivo del equipo para ese d\u00eda. Un d\u00eda de vacaciones, baja o fiesta el objetivo de quien falta es 0 y, con RED.OBJ.MEN activado, su parte se reparte entre los que s\u00ed trabajan ese d\u00eda: el objetivo del equipo para el d\u00eda no baja. Es el mismo n\u00famero que ense\u00f1a Planificaci\u00f3n Diaria para ese d\u00eda.')">i</span></span>
            <span style="font-size:10px;opacity:0.7">{{ datos.matrizProgresiva.diasInfo.length }} d&iacute;as h&aacute;biles &middot; Importes en miles (&euro;)</span>
          </div>
          <div ref="matrizScroll" style="overflow-x:auto">
            <table class="tabla-matriz" style="border-collapse:collapse;font-size:10px;min-width:100%">
              <thead>
                <tr style="background:#f0f4fa;position:sticky;top:0;z-index:2">
                  <th class="col-sem-fix" style="position:sticky;left:0;z-index:3;background:#f0f4fa;padding:4px 8px;text-align:left;min-width:60px">C&Oacute;D</th>
                  <th v-for="d in datos.matrizProgresiva.diasInfo" :key="'pdh-'+d.dia" style="padding:3px 2px;text-align:center;min-width:42px;max-width:48px;font-weight:700;font-size:10px" :style="getHeaderDiaStyle(d)">{{ d.dia }}</th>
                  <th style="padding:4px 8px;text-align:center;min-width:70px;font-weight:700;background:#e8ecf1">TOTAL</th>
                </tr>
                <tr style="background:#f8f9fb;position:sticky;top:24px;z-index:2">
                  <th class="col-sem-fix" style="position:sticky;left:0;z-index:3;background:#f8f9fb;padding:2px 8px"></th>
                  <th v-for="d in datos.matrizProgresiva.diasInfo" :key="'pdd-'+d.dia" style="padding:1px 2px;text-align:center;font-size:9px;color:#888;font-weight:400" :style="getHeaderDiaStyle(d)">{{ d.diaSemana }}</th>
                  <th style="background:#e8ecf1"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="persona in personasFiltradas" :key="'pd-'+persona.codigo">
                  <td class="col-sem-fix" style="position:sticky;left:0;z-index:1;padding:3px 8px;font-weight:600;font-size:10px;background:#fafcff;white-space:nowrap" :title="persona.nombre || persona.codigo">{{ persona.codigo }}</td>
                  <td v-for="d in datos.matrizProgresiva.diasInfo" :key="'pdc-'+persona.codigo+'-'+d.dia" style="padding:2px 1px;text-align:center;font-size:9px;border-right:1px solid #f0f0f0" :style="getCeldaDiaStyle(d)" :class="getCeldaPlanClass(persona, d.dia)">
                    <template v-if="esAusenciaPersonaDia(persona, d.dia)">
                      <span :class="'badge-aus-' + persona.ausenciasPorDia[String(d.dia)]" style="font-size:8px;padding:1px 3px">{{ getLetraAusencia(persona.ausenciasPorDia[String(d.dia)]) }}</span>
                    </template>
                    <template v-else-if="getImporteDiaPersona(persona, d.dia) > 0">{{ fmtNum(Math.round(getImporteDiaPersona(persona, d.dia))) }}</template>
                    <template v-else><span style="color:#ddd">&mdash;</span></template>
                  </td>
                  <td style="padding:3px 6px;text-align:right;font-weight:700;background:#f5f7fa;font-size:10px">{{ fmtNum(persona.totalPlan || 0) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="background:#f0f4fa;font-weight:700">
                  <td class="col-sem-fix" style="position:sticky;left:0;z-index:1;padding:3px 8px;font-size:10px;background:#f0f4fa">TOTAL</td>
                  <td v-for="d in datos.matrizProgresiva.diasInfo" :key="'pdt-'+d.dia" style="padding:2px 1px;text-align:center;font-size:9px;border-right:1px solid #e0e0e0" :style="getCeldaDiaStyle(d)" :class="getCeldaTotalClass(d.dia)">
                    <template v-if="getTotalDiaPersonas(d.dia) > 0">{{ fmtNum(Math.round(getTotalDiaPersonas(d.dia))) }}</template>
                    <template v-else><span style="color:#ddd">&mdash;</span></template>
                  </td>
                  <td style="padding:3px 6px;text-align:right;font-size:10px;background:#e8ecf1">{{ fmtNum(getTotalPlanificadoPersonas()) }}</td>
                </tr>
                <tr style="background:#f8f9fb">
                  <td class="col-sem-fix" style="position:sticky;left:0;z-index:1;padding:3px 8px;font-size:9px;background:#f8f9fb;color:#888">OBJ/D&Iacute;A</td>
                  <td v-for="d in datos.matrizProgresiva.diasInfo" :key="'pdo-'+d.dia" style="padding:2px 1px;text-align:center;font-size:9px;color:#888;border-right:1px solid #f0f0f0" :style="esViernes(d.diaSemana) ? 'border-right:2px solid #aaa' : ''">{{ fmtObj(Math.round(getTotalObjDiaTodas(d.dia))) }}</td>
                  <td style="padding:3px 6px;text-align:right;font-size:9px;color:#888;background:#f8f9fb">{{ fmtObj(datos.objetivoTotal || 0) }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div style="padding:6px 14px;display:flex;gap:12px;font-size:10px;background:#fafbfc;border-top:1px solid #e5e7eb;flex-wrap:wrap">
            <span><span class="celda-excellent" style="padding:1px 6px;border-radius:2px;font-size:9px">&gt;100%</span></span>
            <span><span class="celda-good" style="padding:1px 6px;border-radius:2px;font-size:9px">98-100%</span></span>
            <span><span class="celda-warning" style="padding:1px 6px;border-radius:2px;font-size:9px">94-97%</span></span>
            <span><span class="celda-critical" style="padding:1px 6px;border-radius:2px;font-size:9px">&lt;94%</span></span>
            <span style="margin-left:8px"><span class="badge-aus-vac" style="font-size:9px;padding:1px 4px">V</span> Vac</span>
            <span><span class="badge-aus-bl" style="font-size:9px;padding:1px 4px">B</span> Baja</span>
            <span><span class="badge-fest-mini" style="font-size:9px">F</span> Fiesta</span>
            <span><span class="badge-aus-comp" style="font-size:9px;padding:1px 4px">C</span> Comp</span>
            <span style="margin-left:8px;color:#888"><span style="background:#E3F2FD;padding:1px 4px;border-radius:2px">Hoy</span></span>
            <span style="color:#888"><span style="border-right:2px solid #999;padding-right:4px">V</span> fin semana</span>
          </div>
        </div>

        <!-- REGISTRO PROGRESIVO DE ANTICIPACI&Oacute;N -->
        <div v-if="datos && datos.registroProgresivo && datos.registroProgresivo.dias" class="card-comp" style="margin:12px 0 8px 0;border-radius:8px;overflow:hidden">
          <div style="background:#1a2744;color:white;padding:8px 14px;font-size:12px;font-weight:600">
            <div>Registro progresivo de anticipaci&oacute;n &mdash; % de semana siguiente confirmado <span class="toggle-info-btn" style="margin-left:6px;border-color:rgba(255,255,255,0.4)" @click.stop="abrirTooltipKpi($event, 'Registro progresivo de anticipaci\u00f3n', 'Registra d\u00eda a d\u00eda cu\u00e1nto de la semana SIGUIENTE est\u00e1 confirmado. Objetivo: llegar al viernes con \u2265100%. Los umbrales suben cada d\u00eda: L\u226550%, M\u226560%, X\u226570%, J\u226580%, V\u226590%. Colores: rojo fuerte (bajo base), rojo suave (base a +4%), amarillo (+5 a +9%), verde (\u2265+10%), azul (>+10%). El valor se calcula como: suma de importeReparto confirmado PARA la semana siguiente, con fechaConfirmacionPlanificacion HASTA ese d\u00eda, dividido entre el objetivo de la semana siguiente. El objetivo termina con el mes: una semana que cruza el cambio de mes tiene un objetivo en cada uno, y aqu\u00ed cada fila ense\u00f1a solo la parte del mes en el que est\u00e1, marcada como \u00absemana parcial\u00bb. La otra parte aparece en el mes siguiente, en la fila de su d\u00eda 1, con el porcentaje que ten\u00eda confirmado al empezar la semana (no cabe en las columnas L-V, que miden la semana siguiente). Por eso esa semana ense\u00f1a un objetivo m\u00e1s bajo: es media semana, no menos actividad.')">i</span></div>
            <div style="font-size:10px;opacity:0.7;margin-top:2px">Cada d&iacute;a registra cu&aacute;nto de la semana siguiente est&aacute; confirmado. Objetivo: viernes &ge;100%. Umbrales: L&ge;50% M&ge;60% X&ge;70% J&ge;80% V&ge;90%. Las semanas partidas entre dos meses se marcan &laquo;semana parcial&raquo;: solo cuentan sus d&iacute;as de ese mes</div>
          </div>
          <div ref="registroScroll" style="overflow-y:auto;max-height:500px">
            <table class="tabla-registro" style="border-collapse:collapse;width:100%">
              <thead>
                <tr style="background:#f0f4fa;position:sticky;top:0;z-index:2">
                  <th style="padding:6px 10px;text-align:left;min-width:130px;position:sticky;left:0;background:#f0f4fa;z-index:3;font-size:12px">Fecha</th>
                  <th style="padding:6px 12px;text-align:center;min-width:65px;font-size:12px">L<br><span style="font-size:9px;color:#888">&ge;50%</span></th>
                  <th style="padding:6px 12px;text-align:center;min-width:65px;font-size:12px">M<br><span style="font-size:9px;color:#888">&ge;60%</span></th>
                  <th style="padding:6px 12px;text-align:center;min-width:65px;font-size:12px">X<br><span style="font-size:9px;color:#888">&ge;70%</span></th>
                  <th style="padding:6px 12px;text-align:center;min-width:65px;font-size:12px">J<br><span style="font-size:9px;color:#888">&ge;80%</span></th>
                  <th style="padding:6px 12px;text-align:center;min-width:65px;font-size:12px">V<br><span style="font-size:9px;color:#888">&ge;90%</span></th>
                  <th style="padding:6px 10px;text-align:right;min-width:80px;background:#e8ecf1;font-size:12px">Obj.S+1</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(d, idx) in datos.registroProgresivo.dias">
                  <tr v-if="idx === 0 || d.mes !== datos.registroProgresivo.dias[idx-1].mes" :key="'rm-'+d.fecha" style="background:#1a2744">
                    <td colspan="7" style="padding:6px 10px;color:white;font-weight:700;font-size:13px;position:sticky;left:0">{{ d.mesAbr }} {{ datos.anio }}</td>
                  </tr>
                  <tr :key="'rd-'+d.fecha" :class="{'fila-mes-actual': d.mes === datos.mes}" :style="getFilaDiaStyle(d, idx)">
                    <td style="padding:4px 10px;font-weight:600;font-size:12px;white-space:nowrap;position:sticky;left:0;z-index:1"
                        :style="d.mes === datos.mes ? 'background:#f0f7ff' : (d.mes % 2 === 0 ? 'background:#fafafa' : 'background:white')">
                      {{ d.diaMes }} {{ d.mesAbr }}
                      <span style="color:#888;font-weight:400;font-size:10px;margin-left:4px">{{ d.diaSemana }}</span>
                      <span style="color:#aaa;font-weight:400;font-size:9px;margin-left:4px">S{{ d.semana }}</span>
                      <span style="color:#bbb;font-size:8px;margin-left:2px">&rarr;S{{ d.semanaSiguiente }}</span>
                    </td>
                    <td v-for="(letra, colIdx) in ['L','M','X','J','V']" :key="'rc-'+d.fecha+'-'+letra"
                        style="padding:4px 6px;text-align:center;font-size:11px;font-weight:700"
                        :class="getClaseRegistroCelda(d, colIdx)">
                      <template v-if="regPctTxt(d, colIdx)">{{ regPctTxt(d, colIdx) }}</template>
                      <template v-else><span style="color:#eee">&mdash;</span></template>
                    </td>
                    <td style="padding:4px 8px;text-align:right;font-size:11px;color:#888" :style="d.mes % 2 === 0 ? 'background:#fafafa' : ''">
                      <template v-if="d.diaSemana === 'L'">
                        <!-- El objetivo de la semana sale del cálculo del mes contra el que se mide
                             —que no es el de la fila, ver regObjSigFiable—: si no es fiable, el 0 que
                             llega se leería como «esta semana no hay objetivo». -->
                        <span v-if="!regObjSigFiable(d)" style="color:#bbb">n/d</span>
                        <template v-else>
                          {{ d.objetivoSiguiente > 0 ? fmtNum(d.objetivoSiguiente) : '' }}
                          <div v-if="d.objetivoSiguienteParcial && d.objetivoSiguiente > 0" class="reg-semana-parcial">semana parcial</div>
                        </template>
                      </template>
                      <!-- Resto de una semana partida: lo que de ella cuenta ya contra este mes. Que la
                           semana esté partida lo dice objetivoRestoSemana, no su importe, así que la
                           fila se sigue viendo aunque el objetivo no se conozca. -->
                      <template v-else-if="regObjRestoFiable(d) ? d.objetivoResto > 0 : d.objetivoRestoSemana > 0">
                        <span style="color:#aaa;font-size:9px">S{{ d.objetivoRestoSemana }}</span>
                        <span v-if="!regObjRestoFiable(d)" style="color:#bbb">n/d</span>
                        <template v-else>{{ fmtNum(d.objetivoResto) }}</template>
                        <div class="reg-semana-parcial">semana parcial</div>
                        <!-- Su cumplimiento no cabe en las columnas L-V, que miden la semana
                             siguiente: va aquí, pegado al objetivo contra el que se mide. -->
                        <div v-if="regPctRestoTxt(d)"><span class="reg-resto-pct" :class="regPctRestoClase(d)">{{ regPctRestoTxt(d) }}</span></div>
                      </template>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div style="padding:6px 14px;display:flex;gap:10px;font-size:10px;background:#fafbfc;border-top:1px solid #e5e7eb;flex-wrap:wrap">
            <span><span class="reg-rojo-fuerte" style="padding:1px 6px;border-radius:2px;font-size:9px">&lt;base</span></span>
            <span><span class="reg-rojo-suave" style="padding:1px 6px;border-radius:2px;font-size:9px">base~+4</span></span>
            <span><span class="reg-amarillo" style="padding:1px 6px;border-radius:2px;font-size:9px">+5~+9</span></span>
            <span><span class="reg-verde" style="padding:1px 6px;border-radius:2px;font-size:9px">&ge;+10</span></span>
            <span><span class="reg-azul" style="padding:1px 6px;border-radius:2px;font-size:9px">&gt;+10</span></span>
          </div>
        </div>

        <!-- 4 PANELES DESGLOSE CRUZADO -->
        <div v-if="datos && personasFiltradas.length" style="margin-top:12px">
          <div v-for="panel in paneles" :key="panel.clave" class="panel-desglose">
            <div class="panel-header" @click="panelExpandido = panelExpandido === panel.clave ? null : panel.clave">
              <span>{{ panelExpandido === panel.clave ? '&#9660;' : '&#9654;' }} {{ panel.titulo }} <span class="kpi-info-btn" @click.stop="abrirTooltipKpi($event, panel.titulo, panel.desc)">i</span></span>
            </div>
            <div v-if="panelExpandido === panel.clave" style="overflow-x:auto;margin-top:4px;padding:0 12px 12px">
              <table style="border-collapse:collapse;font-size:10px;width:100%">
                <thead>
                  <tr style="background:#f8f9fb">
                    <th style="padding:4px 8px;text-align:left;min-width:120px;position:sticky;left:0;background:#f8f9fb;z-index:1">{{ panel.tituloFila }}</th>
                    <th v-for="persona in personasFiltradas" :key="'ph-'+panel.clave+'-'+persona.codigo" style="padding:4px 6px;text-align:center;min-width:60px;font-size:9px" :title="persona.nombre || persona.codigo">{{ persona.codigo }}</th>
                    <th style="padding:4px 8px;text-align:right;min-width:70px;background:#e8ecf1;font-weight:700">TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cat in getCategorias(panel.clave)" :key="'pr-'+panel.clave+'-'+cat" style="border-bottom:1px solid #f0f0f0">
                    <td style="padding:3px 8px;font-weight:500;position:sticky;left:0;background:white;z-index:1;white-space:nowrap">{{ cat }}</td>
                    <td v-for="persona in personasFiltradas" :key="'pc-'+panel.clave+'-'+cat+'-'+persona.codigo" style="padding:3px 4px;text-align:center;font-size:9px;border-right:1px solid #f0f0f0">
                      <template v-if="getValorPanel(persona, panel.clave, cat) > 0">{{ fmtNum(Math.round(getValorPanel(persona, panel.clave, cat))) }}</template>
                      <template v-else><span style="color:#eee">&mdash;</span></template>
                    </td>
                    <td style="padding:3px 6px;text-align:right;font-weight:600;background:#f5f7fa;font-size:10px">{{ fmtNum(getTotalCategoria(panel.clave, cat)) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="background:#f0f4fa;font-weight:700">
                    <td style="padding:3px 8px;position:sticky;left:0;background:#f0f4fa;z-index:1">TOTAL</td>
                    <td v-for="persona in personasFiltradas" :key="'pt-'+panel.clave+'-'+persona.codigo" style="padding:3px 4px;text-align:center;font-size:9px">{{ fmtNum(Math.round(getTotalPersonaPanel(persona, panel.clave))) }}</td>
                    <td style="padding:3px 6px;text-align:right;background:#e8ecf1;font-size:10px">{{ fmtNum(getGranTotalPanel(panel.clave)) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- INFO INFERIOR -->
        <div v-if="datos" style="padding:8px 16px;font-size:11px;color:#999">
          {{ nombresMeses[mes - 1] }} {{ anio }} &middot; {{ datos.diasHabiles }} d&iacute;as h&aacute;biles &middot; {{ datos.diasTranscurridos }} transcurridos &middot; {{ personasFiltradas.length }} planificadores
        </div>

        <!-- POPUP ENVIAR REPORTE -->
        <div v-if="popupReporte" class="guia-overlay" @click="popupReporte = false">
          <div class="guia-popup" @click.stop style="width:460px;max-height:80vh">
            <div style="background:linear-gradient(135deg,#1a2744,#2d5f8a);padding:14px 16px;display:flex;justify-content:space-between;align-items:center">
              <div style="font-size:14px;font-weight:700;color:#fff">{{ reporteTipo === 'DIARIO' ? 'Informe diario' : reporteTipo === 'SEMANAL' ? 'Informe semanal' : 'Informe mensual' }} &mdash; Productividad Planificaci&oacute;n</div>
              <span @click="popupReporte = false" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
            </div>
            <div style="padding:16px;overflow-y:auto">
              <div style="margin-bottom:12px">
                <label style="font-size:11px;font-weight:600;color:#555;display:block;margin-bottom:4px">Tipo de reporte</label>
                <div style="display:flex;gap:8px">
                  <div v-for="t in ['DIARIO','SEMANAL','MENSUAL']" :key="'rt-'+t" @click="cambiarTipoReporte(t)" style="flex:1;padding:8px;text-align:center;border-radius:6px;cursor:pointer;font-size:11px;font-weight:600" :style="reporteTipo === t ? 'border:2px solid #1a2744;background:rgba(26,39,68,0.05);color:#1a2744' : 'border:1px solid #ddd;color:#64748b'">{{ t }}</div>
                </div>
              </div>
              <div style="margin-bottom:12px">
                <label style="font-size:11px;font-weight:600;color:#555;display:block;margin-bottom:4px">Destinatarios (separados por coma)</label>
                <textarea v-model="reporteEmails" rows="2" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:12px;box-sizing:border-box" placeholder="email1@empresa.com, email2@empresa.com"></textarea>
              </div>
              <div style="margin-bottom:12px">
                <label style="font-size:11px;font-weight:600;color:#555;display:block;margin-bottom:4px">CC (opcional)</label>
                <input v-model="reporteCc" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:12px;box-sizing:border-box">
              </div>
              <div style="margin-bottom:12px">
                <label style="font-size:11px;font-weight:600;color:#555;display:block;margin-bottom:4px">Asunto</label>
                <input v-model="reporteAsunto" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:12px;box-sizing:border-box">
              </div>
              <!-- Desde la #15 el envio recalcula los datos antes de generar el correo, asi que puede
                   tardar hasta un minuto. Se dice en el boton: si solo pusiera "Enviando..." pareceria
                   colgado y quien lo mira acabaria volviendo a pulsar. -->
              <div style="text-align:right;margin-top:16px">
                <span @click="popupReporte = false" style="padding:6px 16px;border-radius:6px;font-size:11px;cursor:pointer;color:#666;margin-right:8px">Cancelar</span>
                <span @click="confirmarEnvioReporte" :style="enviandoReporte ? 'opacity:0.5;pointer-events:none' : ''" style="background:#0d6efd;color:#fff;padding:6px 20px;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600">{{ enviandoReporte ? 'Recalculando y enviando...' : 'Enviar' }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- POPUP GU\u00cdA DE USO -->
      <div v-if="popupInfo" class="guia-overlay" @click="popupInfo = false">
        <div class="guia-popup" @click.stop>
          <div class="guia-hdr">
            <div style="display:flex;align-items:center;gap:10px">
              <span style="font-size:24px">&#128202;</span>
              <div><div style="font-size:16px;font-weight:800;color:#fff">Gu&iacute;a de uso</div><div style="font-size:10px;color:rgba(255,255,255,.6)">PRODUCTIVIDAD PLANIFICACI&Oacute;N</div></div>
            </div>
            <div style="display:flex;align-items:center;gap:6px">
              <span style="background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff">{{ instrucciones.length }}</span>
              <span @click="modoEdicion = !modoEdicion" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:13px;cursor:pointer;display:flex;align-items:center;justify-content:center" :style="modoEdicion ? 'background:rgba(255,255,255,.3)' : ''" title="Editar">&#9998;</span>
              <span @click="popupInfo = false" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
            </div>
          </div>
          <div style="padding:8px 16px;flex-shrink:0">
            <div style="position:relative;display:flex;align-items:center">
              <span style="position:absolute;left:10px;font-size:13px;color:#94a3b8">&#128269;</span>
              <input v-model="buscarInstr" placeholder="Buscar..." style="width:100%;padding:8px 8px 8px 32px;border:1px solid #e2e8f0;border-radius:8px;font-size:13px;outline:none">
              <span v-if="buscarInstr" @click="buscarInstr = ''" style="position:absolute;right:8px;cursor:pointer;color:#94a3b8;font-size:14px">&times;</span>
            </div>
          </div>
          <div style="flex:1;overflow-y:auto;padding:0 16px 16px;background:linear-gradient(180deg,#f8fafc,#f0f2f5)">
            <div v-for="(inst, idx) in instFiltradas" :key="inst.id || idx" style="background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid #1a2744;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.04)">
              <div @click="expandedInst = expandedInst === idx ? null : idx" style="display:flex;gap:10px;padding:10px;cursor:pointer;align-items:center">
                <span style="min-width:26px;height:26px;background:#1a2744;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800">{{ inst.orden != null ? inst.orden + 1 : idx + 1 }}</span>
                <span style="flex:1;font-size:13px;font-weight:600;color:#1e293b">{{ inst.titulo }}</span>
                <span v-if="modoEdicion" @click.stop="moverInstruccion(inst, -1)" style="cursor:pointer;font-size:11px;color:#94a3b8;padding:2px 4px" title="Subir">&#9650;</span>
                <span v-if="modoEdicion" @click.stop="moverInstruccion(inst, 1)" style="cursor:pointer;font-size:11px;color:#94a3b8;padding:2px 4px" title="Bajar">&#9660;</span>
                <span v-if="modoEdicion" @click.stop="eliminarInstruccion(inst)" style="cursor:pointer;font-size:12px;color:#dc3545;padding:2px 4px" title="Eliminar">&#10005;</span>
                <span style="font-size:10px;color:#94a3b8">{{ expandedInst === idx ? '&#9650;' : '&#9660;' }}</span>
              </div>
              <div v-if="expandedInst === idx" style="padding:0 12px 12px;border-top:1px solid #f1f5f9">
                <template v-if="modoEdicion">
                  <input v-model="inst.titulo" style="width:100%;padding:6px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:13px;font-weight:600;margin-top:8px;outline:none" placeholder="T&iacute;tulo">
                  <textarea v-model="inst.texto" rows="4" style="width:100%;padding:6px 8px;border:1px solid #e2e8f0;border-radius:6px;font-size:12px;margin-top:6px;outline:none;resize:vertical" placeholder="Contenido"></textarea>
                  <div style="margin-top:6px;text-align:right">
                    <span @click="guardarInstruccion(inst)" style="background:#198754;color:#fff;padding:4px 12px;border-radius:4px;font-size:11px;cursor:pointer;font-weight:600">Guardar</span>
                  </div>
                </template>
                <template v-else>
                  <div style="font-size:12.5px;line-height:1.6;color:#334155;padding-top:8px">{{ inst.texto }}</div>
                </template>
              </div>
            </div>
            <div v-if="modoEdicion" style="text-align:center;padding:8px">
              <span @click="nuevaInstruccion" style="background:#1a2744;color:#fff;padding:6px 16px;border-radius:6px;font-size:11px;cursor:pointer;font-weight:600">+ Nuevo apartado</span>
            </div>
            <div v-if="!instFiltradas.length" style="text-align:center;padding:40px;font-size:12px;color:#94a3b8">Sin resultados</div>
          </div>
        </div>
      </div>

    </f7-page-content>
  </f7-page>
</template>

<style scoped>
.contenido-pp { padding:8px 12px; }
.mes-selector { display:flex; align-items:center; justify-content:center; gap:8px; padding:8px 0; }
.sel-anio, .sel-mes { font-size:14px; font-weight:700; border:1px solid #ddd; border-radius:6px; padding:4px 8px; color:#1a2744; }

/* KPIs */
.kpi-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(110px, 1fr)); gap:6px; padding:0 0 8px; }
.kpi-card { border-radius:0.5em; padding:0.6em 0.8em; text-align:center; background:#fff; border:1px solid #e0e0e0; }
.kpi-label { font-size:9px; text-transform:uppercase; letter-spacing:0.3px; font-weight:600; color:#7c8db0; }
.kpi-val { font-size:18px; font-weight:700; color:#1a2744; margin-top:2px; }
.kpi-dark { background:#1a2744; border-color:#1a2744; } .kpi-dark .kpi-label { color:#a8cceb; } .kpi-dark .kpi-val { color:#fff; }
.kpi-blue { background:#E6F1FB; border-color:#E6F1FB; } .kpi-blue .kpi-label { color:#0C447C; } .kpi-blue .kpi-val { color:#0C447C; }
.kpi-green { background:#E8F5E9; border-color:#E8F5E9; } .kpi-green .kpi-label { color:#1B5E20; } .kpi-green .kpi-val { color:#1B5E20; }
.kpi-yellow { background:#FFF9E6; border-color:#FFF9E6; } .kpi-yellow .kpi-label { color:#856404; } .kpi-yellow .kpi-val { color:#856404; }
.kpi-red { background:#FEE2E2; border-color:#FEE2E2; } .kpi-red .kpi-label { color:#991B1B; } .kpi-red .kpi-val { color:#991B1B; }
.kpi-grey { background:#f5f7fa; border-color:#e0e0e0; } .kpi-grey .kpi-label { color:#7c8db0; }
.kpi-editable { background:#fff; border:2px solid #1a2744; }
.kpi-input-edit { width:50px; text-align:center; font-size:16px; font-weight:700; color:#1a2744; background:transparent; border:none; border-bottom:2px dashed #1a2744; outline:none; }

/* Toggles */
.toggles-pp { display:flex; flex-wrap:wrap; gap:6px; padding:0 0 8px; align-items:center; }
.t-btn { font-size:10px; font-weight:600; padding:4px 10px; border-radius:4px; cursor:pointer; user-select:none; transition:all 0.15s; white-space:nowrap; }
.toggle-info-btn { width:13px; height:13px; background:rgba(255,255,255,0.3); border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:8px; font-weight:700; cursor:pointer; flex-shrink:0; }
.kpi-info-btn { display:inline-flex; align-items:center; justify-content:center; width:12px; height:12px; border-radius:50%; background:rgba(0,0,0,0.1); font-size:7px; font-weight:700; cursor:pointer; color:inherit; opacity:0.6; vertical-align:middle; margin-left:2px; }
.kpi-info-btn:hover { opacity:1; background:rgba(0,0,0,0.2); }
.kpi-dark .kpi-info-btn, .kpi-blue .kpi-info-btn { background:rgba(255,255,255,0.25); } .kpi-dark .kpi-info-btn:hover, .kpi-blue .kpi-info-btn:hover { background:rgba(255,255,255,0.4); }

/* Gu\u00eda de uso */
.guia-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:200; background:rgba(0,0,0,0.4); }
.guia-popup { position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); z-index:201; width:650px; max-height:85vh; background:#fff; border-radius:12px; box-shadow:0 8px 30px rgba(0,0,0,0.25); display:flex; flex-direction:column; overflow:hidden; }
.guia-hdr { background:linear-gradient(135deg,#1a2744,#2d5f8a); padding:14px 16px 12px; display:flex; justify-content:space-between; align-items:center; flex-shrink:0; }
.tooltip-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:250; background:transparent; }
.tooltip-fixed { position:fixed; background:#1a2744; color:#fff; padding:10px 14px; border-radius:8px; font-size:12px; line-height:1.5; max-width:280px; min-width:180px; z-index:300; box-shadow:0 4px 16px rgba(0,0,0,0.25); font-weight:400; }

/* Tabla */
.tabla-wrap { border:1px solid #dbe1ec; border-radius:8px; overflow:hidden; margin-bottom:8px; }
.tabla-scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; }
.tabla-pp { width:100%; border-collapse:collapse; font-size:11px; }
.tabla-pp th { position:sticky; top:0; z-index:2; background:#1a2744; color:white; font-size:10px; font-weight:600; padding:0.4em 0.3em; text-align:center; white-space:nowrap; }
.tabla-pp td { padding:0.25em 0.3em; border-bottom:1px solid #eef1f7; vertical-align:middle; }
.col-sticky { position:sticky; left:0; z-index:3; background:inherit; }
.col-codigo { min-width:55px; max-width:70px; font-size:11px; font-weight:600; text-align:center; white-space:nowrap; }
thead .col-codigo { z-index:4; background:#0f1b30; }
.fila-alt td { background:#f8f9fb; } .fila-alt .col-sticky { background:#f8f9fb; }
.fila-persona td { background:#fff; } .fila-persona .col-sticky { background:#fff; }
.col-pct { min-width:40px; text-align:center; font-size:10px; }
.col-num { min-width:50px; text-align:right; font-size:10px; }
.col-dia { min-width:28px; max-width:35px; text-align:center; font-size:10px; color:#7c8db0; }
.col-multi { min-width:120px; padding:0.2em 0.3em !important; vertical-align:middle; }
.multi-center { display:flex; flex-direction:column; gap:1px; align-items:center; justify-content:center; font-size:12px; }
.col-sem { min-width:40px; max-width:50px; padding:0.2em 0.3em !important; text-align:center; font-size:10px; }
.col-res { min-width:60px; font-size:11px; font-weight:500; text-align:right; }
.sem-fechas { font-size:0.75em; color:#7c8db0; }
.col-total { min-width:65px; text-align:right; font-weight:600; }
.col-sep-left { border-left:2px solid #c8d0de !important; }
thead .col-sep-left { border-left:2px solid #3d5278 !important; }
.celda-sem { display:flex; flex-direction:column; gap:1px; align-items:center; font-size:11px; }
.val-line { display:flex; align-items:center; justify-content:flex-end; gap:3px; white-space:nowrap; line-height:1.2; font-weight:500; }
.vdot { display:inline-block; width:7px; height:7px; border-radius:50%; flex-shrink:0; }
.dia-vac { background:#FFF9E6 !important; color:#856404 !important; font-weight:600; }
.dia-ausencia-sem { background:#FFF3CD !important; color:#856404 !important; font-weight:600; }
.dia-bl { background:#FEE2E2 !important; color:#991B1B !important; font-weight:600; }
.dia-comp { background:#EDE9FE !important; color:#5B21B6 !important; font-weight:600; }
.fila-obj td { background:#f0f4fa; font-size:11px; font-weight:600; padding:0.35em; color:#1a2744; text-align:right; }
.fila-obj .col-sticky { background:#f0f4fa; }
.fila-pct td { background:#f5f7fa; font-size:11px; padding:0.35em; text-align:center; }
.fila-pct .col-sticky { background:#f5f7fa; }
.badge-pct-sem { display:inline-block; padding:2px 8px; border-radius:3px; font-size:10px; font-weight:700; }
.card-comp { box-shadow:0 1px 3px rgba(0,0,0,0.12); }
.tabla-matriz td { border-bottom:1px solid #f0f0f0; }
.tabla-matriz .fila-mes-actual td { background:#fafcff; }
.col-sem-fix { min-width:80px; max-width:100px; }
.badge-pct-mini { display:inline-block; padding:1px 3px; border-radius:2px; font-size:9px; font-weight:700; min-width:28px; text-align:center; }
.badge-fest-mini { display:inline-block; padding:1px 3px; border-radius:2px; font-size:9px; font-weight:700; background:#E040FB; color:white; min-width:16px; text-align:center; }
.tabla-registro td { border-bottom:1px solid #f0f0f0; }
.reg-rojo-fuerte { background:#C62828 !important; color:white !important; }
.reg-rojo-suave { background:#EF5350 !important; color:white !important; }
.reg-amarillo { background:#FFC107 !important; color:black !important; }
.reg-verde { background:#28A745 !important; color:white !important; }
.reg-azul { background:#17A2B8 !important; color:white !important; }
/* Semana partida entre dos meses: su objetivo es el de media semana, no un bajón de actividad. */
.reg-semana-parcial { font-size:8px; font-weight:600; color:#E65100; line-height:1.1; white-space:nowrap; }
.reg-resto-pct { display:inline-block; font-size:9px; font-weight:700; padding:0 4px; border-radius:2px; margin-top:1px; }
.sem-parcial { display:block; font-size:8px; font-weight:600; color:#E65100; line-height:1.1; }
.fila-semana-actual td { background:#E3F2FD !important; }
.celda-critical { background:#FDEDEE !important; color:#991B1B !important; font-weight:600; }
.celda-warning { background:#FFF9E6 !important; color:#856404 !important; font-weight:600; }
.celda-good { background:#E8F5E9 !important; color:#1B5E20 !important; font-weight:600; }
.celda-excellent { background:#E0F7FA !important; color:#006064 !important; font-weight:600; }
.badge-aus-comp { display:inline-block; padding:1px 4px; border-radius:3px; font-size:9px; font-weight:700; background:#9C27B0; color:white; }
.badge-fest { display:inline-block; padding:2px 8px; border-radius:3px; font-size:10px; font-weight:700; background:#E040FB; color:white; }
.pct-critical { background:#DC3545; color:white; }
.pct-warning { background:#FFC107; color:black; }
.pct-good { background:#28A745; color:white; }
.pct-excellent { background:#17A2B8; color:white; }
.val-pos { color:#1B5E20 !important; } .val-neg { color:#991B1B !important; }
.val-warn { color:#E65100 !important; font-weight:600; background:#FFF3E0 !important; }
.badge-pct { display:inline-block; padding:1px 6px; border-radius:2em; font-size:10px; font-weight:600; }
.badge-pct.pct-high { background:#D5F5E3; color:#0E6251; }
.badge-pct.pct-mid { background:#FFF9E6; color:#856404; }
.badge-pct.pct-low { background:#FADBD8; color:#943126; }

/* Footer */
.fila-totales td { background:#eef1f7; font-size:11px; font-weight:500; padding:0.35em; border-top:2px solid #c8d0de; color:#1a2744; text-align:right; }
.fila-totales .col-sticky { background:#eef1f7; }

/* Paneles */
.panel-desglose { border:1px solid #dbe1ec; border-radius:8px; margin-bottom:6px; overflow:hidden; }
.panel-header { background:#f5f7fa; padding:8px 12px; cursor:pointer; font-size:12px; font-weight:600; color:#1a2744; }
.panel-header:hover { background:#eef1f7; }
.panel-body { padding:0 12px 12px; }
.tabla-panel { width:100%; border-collapse:collapse; font-size:11px; margin-top:8px; }
.tabla-panel th { background:#f5f7fa; padding:4px 8px; text-align:left; font-size:10px; font-weight:600; color:#7c8db0; border-bottom:1px solid #ddd; }
.tabla-panel td { padding:3px 8px; border-bottom:1px solid #f0f2f5; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; display: flex; flex-wrap: wrap; gap: 8px; }
</style>

<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';
import SelloDatos from '../../components/SelloDatos.vue';

/**
 * Tope de espera de una carga. Las peticiones no tienen límite de tiempo y hay respuestas que no
 * llegan a resolver ni a rechazar la promesa (un 401 cierra la sesión sin hacer ninguna de las dos,
 * ver el errorCallback de DatabaseModel.sendRequest), así que sin este tope la pantalla se puede
 * quedar en "Cargando datos..." para siempre y sin decir nada.
 */
var ESPERA_MAXIMA_MS = 45000;

export default {
  components: { SelloDatos },
  data: function() {
    return {
      anio: new Date().getFullYear(),
      mes: new Date().getMonth() + 1,
      datos: null,
      // Un "cargando" por operación, no uno compartido: si el POST de Recalcular terminaba
      // mientras la carga del mes seguía en marcha, apagaba el indicador de las dos y la carga
      // colgada se quedaba sin su aviso de que el servidor no había respondido.
      cargas: { carga: false, recalculo: false },
      errorCarga: null,
      guardando: false,
      recalculando: false,
      creandoMes: false,
      redObjMen: false,
      zoom: 100,
      tooltipToggle: null,
      tooltipTogglePos: {},
      tooltipKpiData: null,
      tooltipKpiPos: {},
      popupInfo: false,
      instrucciones: [],
      buscarInstr: '',
      expandedInst: null,
      modoEdicion: false,
      popupReporte: false,
      reporteTipo: 'MENSUAL',
      reporteEmails: '',
      reporteCc: '',
      reporteAsunto: '',
      enviandoReporte: false,
      panelExpandido: null,
      personasOcultas: {},
      configLocal: { porcentajePlanificacion: 0.80, horasPlanificacion: 6 },
      nombresMeses: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
      toggles: { oeb: true, oebR: false, oebP: false, oebPpend: false, planDia: false, planHSem: false, planHDia: false, deltaTpc: false },
      // Valores a los que se vuelve cuando el mes que se abre no tiene toggles guardados.
      togglesDefecto: { oeb: true, oebR: false, oebP: false, oebPpend: false, planDia: false, planHSem: false, planHDia: false, deltaTpc: false },
      togglesDef: [
        { clave: 'oeb', nombre: 'OEB', color: '#1a2744', desc: 'Total confirmado sin filtro TPC.' },
        { clave: 'oebR', nombre: 'OEB-R', color: '#198754', desc: 'TPC=SI. Trabajo de campo confirmado.' },
        { clave: 'oebP', nombre: 'OEB-P', color: '#0d6efd', desc: 'TPC=NO. Confirmado no ejecutado.' },
        { clave: 'oebPpend', nombre: 'OEB-PPEND', color: '#e6a817', desc: 'Planificado pendiente de confirmar (sin F. Confirmaci\u00f3n Plani).' },
        { clave: 'planDia', nombre: 'PLAN/D\u00cdA', color: '#E91E63', desc: 'Confirmado por d\u00eda: total semana / d\u00edas reales de la persona.' },
        { clave: 'planHSem', nombre: 'PLAN/H', color: '#1a2744', desc: 'Confirmado / (d\u00edas semana \u00d7 H.planif).' }
      ],
      redObjMenInfo: { clave: 'redObjMen', nombre: 'RED.OBJ.MEN', desc: 'Reparte el objetivo de quien no trabaja entre los que s\u00ed trabajan ESE d\u00eda. Un d\u00eda de vacaciones, baja o fiesta el objetivo de quien falta es 0 y su parte la absorben los dem\u00e1s a partes iguales, as\u00ed que el objetivo del equipo para ese d\u00eda no baja. El objetivo del mes no cambia: solo cambia c\u00f3mo se reparte entre los d\u00edas, y por eso el TOTAL de quien absorbe sube y el del ausente baja. Sin activar, cada uno cumple su objetivo del mes en sus d\u00edas reales y el objetivo del equipo baja los d\u00edas en que falta alguien. Los fines de semana no tienen objetivo. Pulse de nuevo para volver.' },
      paneles: [
        { clave: 'ejecutor', titulo: 'Desglose por ejecutor (Usu. Ejec. Reparto)', tituloFila: 'Ejecutor', desc: 'Desglose del total confirmado por usuario ejecutor de reparto. Columnas: planificadores. Filas: ejecutores ordenados por importe descendente.' },
        { clave: 'materia', titulo: 'Desglose por materia', tituloFila: 'Materia', desc: 'Desglose por materia de inspecci\u00f3n (AE, REBT, PCI, RITE...). Muestra cu\u00e1nto ha confirmado cada planificador en cada materia.' },
        { clave: 'provincia', titulo: 'Desglose por provincia de inspecci\u00f3n', tituloFila: 'Provincia', desc: 'Desglose por provincia de inspecci\u00f3n. Muestra la distribuci\u00f3n geogr\u00e1fica de lo confirmado por cada planificador.' },
        { clave: 'contratacion', titulo: 'Desglose por empleado de contrataci\u00f3n', tituloFila: 'Contrataci\u00f3n', desc: 'Desglose por empleado de contrataci\u00f3n. Muestra qu\u00e9 empleado de contrataci\u00f3n origina el trabajo confirmado por cada planificador.' }
      ]
    };
  },
  computed: {
    // "Cargando datos..." se enseña mientras quede alguna operación pendiente (ver cargas).
    cargando: function() {
      return !!(this.cargas.carga || this.cargas.recalculo);
    },
    aniosDisponibles: function() {
      var a = []; for (var i = 2024; i <= new Date().getFullYear() + 1; i++) a.push(i); return a;
    },
    // La API avisa con objetivoFiable=false cuando el objetivo del mes sale de datos incompletos
    // (sin el OEB, o sin las ausencias). Lo confirmado sigue siendo bueno; el objetivo no, y
    // enseñarlo como 0 lo convierte en «objetivo cero»: el cumplimiento sale 0% y la FALTA
    // negativa en verde, como si se hubiera superado. Se dice n/d, igual que Planificación
    // Diaria y el PDF (pdfObjFiable).
    objetivoFiable: function() {
      return !this.datos || this.datos.objetivoFiable !== false;
    },
    // El OEB del mes es aparte: no se calcula con las ausencias, así que si lo único que ha fallado
    // es cargarlas sigue siendo la cifra buena y se enseña. Lo que no vale es enseñar el 0 con el
    // que llega cuando es el propio OEB el que falta, porque se lee como «el OEB del mes es cero».
    oebDisponible: function() {
      if (this.datos && typeof this.datos.oebDisponible === 'boolean') return this.datos.oebDisponible;
      return this.objetivoFiable;
    },
    personasFiltradas: function() {
      if (!this.datos || !this.datos.personas) return [];
      var self = this;
      return this.datos.personas.filter(function(p) {
        return !self.personasOcultas[p.codigo];
      });
    },
    numOcultas: function() {
      var c = 0; for (var k in this.personasOcultas) { if (this.personasOcultas[k]) c++; } return c;
    },
    // R-1: detectar si los % no suman 100, para mostrar aviso no bloqueante.
    // Solo se considera a los planificadores VISIBLES (sin contar ocultos).
    sumaPorcentajes: function() {
      if (!this.personasFiltradas.length) return 0;
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += (p.porcentaje || 0); });
      return t;
    },
    sumaPorcentajesPct: function() {
      return Math.round(this.sumaPorcentajes * 1000) / 10;
    },
    sumaPorcentajesFueraRango: function() {
      var pct = this.sumaPorcentajes;
      return pct > 0 && (pct < 0.995 || pct > 1.005);
    },
    totalPlanificado: function() {
      if (!this.personasFiltradas.length) return 0;
      var t = 0; this.personasFiltradas.forEach(function(p) { t += (p.totalPlan || 0); }); return t;
    },
    pctCumplimiento: function() {
      if (!this.datos || !this.datos.objetivoTotal || this.datos.objetivoTotal <= 0) return 0;
      return Math.round(this.totalPlanificado / this.datos.objetivoTotal * 1000) / 10;
    },
    faltaTotal: function() {
      return (this.datos ? (this.datos.objetivoTotal || 0) : 0) - this.totalPlanificado;
    },
    faltaPorDia: function() {
      if (!this.datos) return 0;
      var diasRestantes = (this.datos.diasHabiles || 0) - (this.datos.diasTranscurridos || 0);
      return diasRestantes > 0 ? Math.round(this.faltaTotal / diasRestantes) : 0;
    },
    /**
     * ¿Hay algo redistribuido que enseñar? El reparto ya no se calcula aquí: la API manda los
     * objetivos por día, por semana y del mes en sus dos versiones —con y sin RED.OBJ.MEN— y esta
     * pantalla solo elige cuál pinta según el toggle. Así responde al momento sin pasar por Guardar
     * y no puede desviarse de lo que enseña Planificación Diaria, que es de donde venía el
     * descuadre. Mientras no se Guarde, Diaria sigue enseñando el estado guardado.
     */
    /** Por qué el objetivo del mes de una persona no es su %Obj cuando hay redistribución. */
    tituloObjetivoPersona: function() {
      return this.redObjMen
        ? 'Suma de sus días, que es lo que suman sus semanas. Con RED.OBJ.MEN sube el de quien absorbe la parte de un ausente y baja el del ausente; entre todos siguen sumando el OBJ. PLANIF. del mes'
        : '';
    },
    hayRedistribucion: function() {
      if (!this.redObjMen || !this.datos || !this.datos.personas) return false;
      return this.datos.personas.some(function(p) {
        return (p.objetivoRed || 0) !== (p.objetivo || 0);
      });
    },
    sumaDR: function() {
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += (p.dr || 0); });
      return t;
    },
    diasRealesMedia: function() {
      if (!this.personasFiltradas.length) return 0;
      return Math.round(this.sumaDR / this.personasFiltradas.length);
    },
    planPorHora: function() {
      var h = this.sumaDR * (this.configLocal.horasPlanificacion || 7);
      return h > 0 ? Math.round(this.totalPlanificado / h) : '0';
    },
    prodMedia: function() {
      return this.sumaDR > 0 ? Math.round(this.totalPlanificado / this.sumaDR) : 0;
    },
    tooltipToggleData: function() {
      if (!this.tooltipToggle) return { nombre: '', desc: '' };
      if (this.tooltipToggle === 'redObjMen') return this.redObjMenInfo;
      for (var i = 0; i < this.togglesDef.length; i++) {
        if (this.togglesDef[i].clave === this.tooltipToggle) return this.togglesDef[i];
      }
      return { nombre: '', desc: '' };
    },
    instFiltradas: function() {
      var q = (this.buscarInstr || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) {
        return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1;
      });
    }
  },
  methods: {
    onPageInit: function() { this.cargarDatos(); },
    ocultarPersona: function(codigo) {
      this.cambiarOculta(codigo, true);
    },
    // Una detras de otra, no nueve a la vez: cada cambio es su propia peticion, y lanzarlas todas
    // juntas encadenaba un aviso de error por cada una y dejaba la lista a medias sin saber cuales
    // habian entrado. Si alguna falla se para ahi, se deshace esa y se avisa UNA vez.
    mostrarTodas: function() {
      var self = this;
      var anio = self.anio;
      var mes = self.mes;
      var pendientes = Object.keys(self.personasOcultas).filter(function(codigo) {
        return self.personasOcultas[codigo];
      });
      var siguiente = function() {
        // Si a media cola se ha cambiado de mes, se para: `cambiarOculta` trabaja sobre el mes que
        // hay en pantalla, y seguir mostraria en el mes NUEVO a quien su dueño tenia oculto ahi.
        if (!pendientes.length || self.anio !== anio || self.mes !== mes) return;
        self.cambiarOculta(pendientes.shift(), false, siguiente);
      };
      siguiente();
    },
    // Relee del servidor SOLO quién está oculto. Recargar la pantalla entera valdría, pero se
    // llevaría por delante los %Obj que se estén editando sin haber pulsado Guardar.
    reconciliarOcultas: function(anio, mes) {
      var self = this;
      Oeb.getProductividadPlan(anio, mes).then(function(res) {
        var datos = unwrapDto(res);
        if (!datos || self.anio !== anio || self.mes !== mes) return;
        var ocultas = {};
        (datos.personas || []).forEach(function(p) { if (p.oculta) ocultas[p.codigo] = true; });
        var prefijo = anio + '-' + mes + '|';
        Object.keys(self._ocultasEnVuelo || {}).forEach(function(clave) {
          if (clave.indexOf(prefijo) !== 0) return;
          var codigo = clave.substring(prefijo.length);
          if (self._ocultasEnVuelo[clave]) ocultas[codigo] = true;
          else delete ocultas[codigo];
        });
        self.personasOcultas = ocultas;
      }).catch(function() { /* si tampoco se puede leer, queda el aviso que ya se ha mostrado */ });
    },
    // Cada cambio se manda solo, para esa persona, igual que en Planificación Diaria, y va contra
    // la lista de este usuario. Ya no espera a Guardar —ese botón mandaba la lista entera—. Si la
    // petición falla se deshace SOLO ese cambio; si se corta sin respuesta no se deshace nada y se
    // relee, porque puede haberse aplicado: lo que se ve tiene que ser lo que hay guardado, que es
    // de donde sale también el informe.
    cambiarOculta: function(codigo, ocultar, alTerminar) {
      var self = this;
      var anio = self.anio;
      var mes = self.mes;
      var estabaOculta = !!self.personasOcultas[codigo];
      if (estabaOculta === ocultar) return;
      self.$set(self.personasOcultas, codigo, ocultar);
      if (!self._ocultasEnVuelo) self._ocultasEnVuelo = {};
      // La clave lleva el mes: lo que se ha pedido es ocultar a alguien en ESTE mes, y solo la
      // carga de este mes tiene que hacerle caso (ver cargarDatos y reconciliarOcultas).
      var clave = anio + '-' + mes + '|' + codigo;
      self._ocultasEnVuelo[clave] = ocultar;
      var peticion = ocultar
        ? Oeb.ocultarPersonaProductividadPlan(anio, mes, codigo)
        : Oeb.mostrarPersonaProductividadPlan(anio, mes, codigo);
      peticion.then(function() {
        delete self._ocultasEnVuelo[clave];
        if (alTerminar) alTerminar();
      }).catch(function(err) {
        delete self._ocultasEnVuelo[clave];
        // La vuelta atrás es del mes al que se pidió el cambio: si ya se ha cambiado de mes,
        // personasOcultas es la de ese otro mes y deshacer ahí escondería a quien no toca.
        if (self.anio !== anio || self.mes !== mes) return;
        // Si la petición se cortó sin respuesta no se sabe si el cambio se aplicó, así que
        // deshacerlo puede dejar la pantalla enseñando justo lo contrario de lo guardado.
        // Se relee el mes, que es la única forma de saber qué quedó.
        if (Oeb.esResultadoIncierto(err)) {
          self.$f7.toast.create({
            text: (err && err.message) || 'La petición no ha respondido; se comprueba si el cambio se aplicó',
            position: 'top', closeTimeout: 4000
          }).open();
          self.reconciliarOcultas(anio, mes);
          return;
        }
        self.$set(self.personasOcultas, codigo, estabaOculta);
        self.$f7.toast.create({
          text: 'No se pudo cambiar la lista de planificadores', position: 'top', closeTimeout: 2000
        }).open();
      });
    },
    cargarDatos: function() {
      var self = this;
      var periodoPedido = self.anio + '-' + self.mes;
      var cargaId = self.nuevoIntento('carga');
      self.cargas.carga = true;
      self.errorCarga = null;
      self.armarEsperaMaxima('carga', periodoPedido, cargaId);
      // Si la carga anterior se agotó sin contestar, esta pide de nuevo al servidor en vez de
      // engancharse a aquella: ver el comentario de _forzarRecarga en armarEsperaMaxima.
      var forzar = self._forzarRecarga === true;
      self._forzarRecarga = false;
      Oeb.getProductividadPlan(self.anio, self.mes, forzar)
        .then(function(res) {
          // Al pasar meses deprisa, la respuesta de una carga anterior puede llegar después que la
          // de la carga en curso: pintarla enseñaría las cifras de otro mes, o más viejas que las
          // ya pintadas si es del mismo mes (Reintentar tras el tope de espera).
          if (!self.esIntentoVigente('carga', cargaId)) return;
          if (self.anio + '-' + self.mes !== periodoPedido) return;
          self.cancelarEsperaMaxima('carga');
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            self._periodoDatos = periodoPedido;
            var cfg = unwrapDto(res).config || {};
            // Todo lo que sale de la config se REASIGNA, nunca se deja lo que hubiera: al cambiar
            // de mes, conservar los planificadores del mes anterior hacía que Guardar escribiera
            // en el mes nuevo los %Obj del viejo.
            self.configLocal.porcentajePlanificacion = cfg.porcentajePlanificacion || 0.80;
            self.configLocal.horasPlanificacion = cfg.horasPlanificacion || 6;
            self.configLocal.planificadores = cfg.planificadores || [];
            self.configLocal.id = cfg.id || null;
            for (var tg in self.togglesDefecto) {
              if (!self.togglesDefecto.hasOwnProperty(tg)) continue;
              var guardado = cfg.togglesGuardados ? cfg.togglesGuardados[tg] : undefined;
              self.$set(self.toggles, tg, guardado != null ? guardado : self.togglesDefecto[tg]);
            }
            // Los ocultos salen de personas[].oculta, que la API marca con la lista de QUIEN
            // pregunta. config.personasOcultas es la lista compartida de antes de este cambio:
            // solo sirve de punto de partida en el servidor y no se lee aquí.
            self.personasOcultas = {};
            (unwrapDto(res).personas || []).forEach(function(p) {
              if (p.oculta) self.$set(self.personasOcultas, p.codigo, true);
            });
            // Un cambio que todavia no ha contestado MANDA sobre lo que traiga el servidor: esta
            // carga pudo pedirse ANTES de que se guardara, y sin esto la persona reaparecia (o
            // desaparecia) aunque el guardado hubiera ido bien. Al contestar la peticion se sale
            // de aqui y vuelve a mandar el servidor.
            //
            // Solo los cambios pedidos para ESTE mes: la lista de ocultos es de un mes concreto,
            // y un cambio en vuelo de junio no dice nada de julio.
            var prefijoEnVuelo = self.anio + '-' + self.mes + '|';
            Object.keys(self._ocultasEnVuelo || {}).forEach(function(clave) {
              if (clave.indexOf(prefijoEnVuelo) !== 0) return;
              var codigo = clave.substring(prefijoEnVuelo.length);
              if (self._ocultasEnVuelo[clave]) self.$set(self.personasOcultas, codigo, true);
              else self.$delete(self.personasOcultas, codigo);
            });
            self.redObjMen = !!(cfg.togglesGuardados && cfg.togglesGuardados.redObjMen);
          }
          self.cargas.carga = false;
          // Una respuesta que llega tarde, después de haber avisado de que no se podía cargar,
          // sigue siendo la buena: se pinta y el aviso desaparece.
          self.errorCarga = null;
          self.$nextTick(function() {
            if (self.$refs.registroScroll) {
              var rows = self.$refs.registroScroll.querySelectorAll('tr');
              var meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
              var mesSelec = meses[self.mes - 1] || '';
              for (var ri = 0; ri < rows.length; ri++) {
                if (rows[ri].querySelector('td[colspan]') && (rows[ri].textContent || '').indexOf(mesSelec) >= 0) {
                  self.$refs.registroScroll.scrollTop = Math.max(0, rows[ri].offsetTop - self.$refs.registroScroll.offsetTop - 10);
                  break;
                }
              }
            }
          });
        }).catch(function(e) {
          // El fallo de una carga que ya no es la vigente no se cuenta: la siguiente puede haber
          // cargado bien, y avisar aquí borraría sus cifras para poner un error ajeno.
          if (!self.esIntentoVigente('carga', cargaId)) return;
          if (self.anio + '-' + self.mes !== periodoPedido) return;
          self.cancelarEsperaMaxima('carga');
          self.cargas.carga = false;
          // Si lo que hay pintado es de otro mes, se quita: con el selector ya en el mes nuevo,
          // dejarlo sería enseñar las cifras de un mes bajo el título de otro.
          if (self._periodoDatos !== periodoPedido) { self.datos = null; self._periodoDatos = null; }
          self.errorCarga = (e && e.message) ? e.message : 'El servidor no ha respondido correctamente.';
        });
    },
    /**
     * Numera los intentos de cada operación. El mes pedido no basta para distinguirlos: al agotarse
     * el tope de espera, Reintentar lanza una segunda petición del mismo mes, y sin este número la
     * primera —que sigue viva— cancelaría el tope de la segunda, apagaría su "cargando" y podría
     * pintar por encima de una respuesta más reciente.
     */
    nuevoIntento: function(operacion) {
      var ids = this._intentos || (this._intentos = {});
      ids[operacion] = (ids[operacion] || 0) + 1;
      return ids[operacion];
    },
    esIntentoVigente: function(operacion, id) {
      var ids = this._intentos || (this._intentos = {});
      return ids[operacion] === id;
    },
    /**
     * Le retira el turno a la carga que estuviera en vuelo. La llama el recálculo al aceptar su
     * respuesta: el número de intento es independiente por operación, así que una carga lanzada
     * ANTES del POST sigue siendo la vigente de 'carga' y, cuando conteste, pintaría encima la foto
     * de antes de recalcular. Al quitarle el turno su .then/.catch salen sin tocar nada, y como ya
     * nadie va a apagar su "cargando" ni su tope de espera, se apagan aquí.
     *
     * El turno se retira SIEMPRE, también cuando ya no se está girando. Una carga a la que se le
     * agotó el tope de espera deja de contar como "cargando" pero sigue siendo la vigente a
     * propósito —su respuesta tardía se sigue pintando, ver armarEsperaMaxima—, así que saltarse
     * este descarte por no estar girando es justo lo que le dejaría pisar las cifras recién
     * recalculadas cuando el POST termina antes que ella.
     */
    descartarCargaEnCurso: function() {
      this.nuevoIntento('carga');
      this.cancelarEsperaMaxima('carga');
      this.cargas.carga = false;
      // Esa petición descartada puede resolverse después y dejar su respuesta vieja en la caché de
      // 60 s del navegador, así que la siguiente carga tiene que ir al servidor sí o sí.
      this._forzarRecarga = true;
    },
    /**
     * Arranca el tope de espera de una petición ('carga' o 'recalculo'). Al agotarse se deja de
     * girar y se dice que no se ha podido cargar, en vez de quedarse en "Cargando datos..." sin
     * fin: la petición puede no volver nunca (ver ESPERA_MAXIMA_MS) y entonces ni el .then ni el
     * .catch llegan a ejecutarse.
     *
     * Cada operación lleva el suyo: con un temporizador único, cargar el mes mientras el recálculo
     * seguía pendiente cancelaba el del recálculo, y si ese POST no volvía nunca el botón se
     * quedaba en "Calculando..." para siempre.
     */
    armarEsperaMaxima: function(operacion, periodoPedido, intentoId) {
      var self = this;
      self.cancelarEsperaMaxima(operacion);
      var timers = self._esperaTimers || (self._esperaTimers = {});
      timers[operacion] = setTimeout(function() {
        timers[operacion] = null;
        // Un tope solo manda sobre su propio intento: si ya hay otro en marcha para la misma
        // operación, es aquel el que decide cuándo se apaga el "cargando" y qué se pinta.
        if (!self.esIntentoVigente(operacion, intentoId)) return;
        // El botón se libera pase lo que pase, igual que en el .then y el .catch de recalcular:
        // si el POST no vuelve nunca, este es el único sitio que lo desatasca.
        if (operacion === 'recalculo') self.recalculando = false;
        var seguiaCargando = self.cargas[operacion];
        // Cada operación apaga solo el suyo: el de la otra puede seguir en marcha y traer datos.
        self.cargas[operacion] = false;
        // La petición sigue colgada y CacheService guarda su promesa pendiente 60 s, más que este
        // tope: sin esta marca, Reintentar devolvería esa misma promesa y volvería a esperarla.
        self._forzarRecarga = true;
        if (!seguiaCargando) return;
        if (self.anio + '-' + self.mes !== periodoPedido) return;
        // Del hueco de "Cargando datos..." manda la otra operación MIENTRAS SIGA VIVA: puede traer
        // sus cifras y pintar aquí un error las borraría. Antes se miraba cuál se lanzó la última,
        // y eso callaba al recálculo también cuando la carga ya había terminado: el botón se
        // soltaba sin éxito ni error y nadie se enteraba de que el recálculo había fallado.
        var otra = operacion === 'carga' ? 'recalculo' : 'carga';
        var otraViva = !!self.cargas[otra];
        // El recálculo siempre contesta, porque su botón se acaba de liberar. Si hay cifras del mes
        // en pantalla —las de antes de recalcular, o las que acaba de traer una carga— se avisa con
        // un toast: el cartel de error taparía datos que sí son buenos y no dicen lo que falló.
        if (operacion === 'recalculo' && (otraViva || self._periodoDatos === periodoPedido)) {
          self.$f7.toast.create({
            text: 'El recálculo no ha respondido a tiempo. Lo que se ve son los datos de antes de recalcular.',
            position: 'top', closeTimeout: 4000
          }).open();
          return;
        }
        if (otraViva) return;
        if (self._periodoDatos !== periodoPedido) { self.datos = null; self._periodoDatos = null; }
        self.errorCarga = operacion === 'recalculo'
          ? 'El recálculo no ha respondido a tiempo. El servidor puede estar caído o tardando más de la cuenta.'
          : 'El servidor no ha respondido a tiempo. Puede estar caído o tardando más de la cuenta.';
      }, ESPERA_MAXIMA_MS);
    },
    /**
     * Sin operación —así llega desde page:beforeremove, que pasa el evento— se cancelan todos:
     * al salir de la pantalla no debe quedar ningún temporizador vivo sobre una vista cerrada.
     */
    cancelarEsperaMaxima: function(operacion) {
      var timers = this._esperaTimers || (this._esperaTimers = {});
      var claves = (typeof operacion === 'string') ? [operacion] : Object.keys(timers);
      claves.forEach(function(clave) {
        if (timers[clave]) { clearTimeout(timers[clave]); timers[clave] = null; }
      });
    },
    recalcular: function() {
      var self = this;
      var periodoPedido = self.anio + '-' + self.mes;
      // Igual que la carga: al agotarse el tope el botón se libera y se puede volver a pulsar, así
      // que el primer POST no debe soltar el botón ni el tope del segundo cuando conteste tarde.
      var recalculoId = self.nuevoIntento('recalculo');
      // #663 · El cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla la continuación que lo soltaba.
      cerrojoDeLaSesion(self, 'recalculando'); self.cargas.recalculo = true;
      self.errorCarga = null;
      self.armarEsperaMaxima('recalculo', periodoPedido, recalculoId);
      Oeb.recalcularProductividadPlan(self.anio, self.mes)
        .then(function(res) {
          // El botón y el "cargando" del recálculo se liberan pase lo que pase —y solo los suyos,
          // que una carga en marcha sigue teniendo que girar—; lo demás solo si el selector sigue
          // en el mes que se mandó recalcular, porque del mes nuevo manda su propia carga.
          if (!self.esIntentoVigente('recalculo', recalculoId)) return;
          self.recalculando = false;
          self.cargas.recalculo = false;
          self.cancelarEsperaMaxima('recalculo');
          if (self.anio + '-' + self.mes !== periodoPedido) return;
          self.errorCarga = null;
          if (unwrapDto(res)) {
            self.descartarCargaEnCurso();
            self.datos = unwrapDto(res);
            self._periodoDatos = periodoPedido;
          }
          self.$f7.toast.create({ text: 'Datos recalculados', position: 'top', closeTimeout: 2000 }).open();
        }).catch(function(e) {
          if (!self.esIntentoVigente('recalculo', recalculoId)) return;
          self.recalculando = false;
          self.cargas.recalculo = false;
          self.cancelarEsperaMaxima('recalculo');
          if (self.anio + '-' + self.mes !== periodoPedido) return;
          var detalle = (e && e.message) ? e.message : '';
          // Si se cortó sin respuesta, el servidor puede haber recalculado igual: darlo por fallido
          // dejaría la pantalla con las cifras de antes y a quien mira pulsando Recalcular otra vez.
          // La caché ya la tiró Oeb.recalcularProductividadPlan; aquí se relee, que es la única
          // forma de saber qué quedó.
          if (Oeb.esResultadoIncierto(e)) {
            self.$f7.toast.create({
              text: 'El recálculo no ha respondido; se comprueba si llegó a aplicarse.',
              position: 'top', closeTimeout: 4000
            }).open();
            self.cargarDatos();
            return;
          }
          // Mismo criterio que el tope de espera: con cifras del mes en pantalla, `errorCarga`
          // pinta "No se han podido cargar los datos del mes" sobre unos datos que están y son
          // buenos, y su Reintentar hace un GET normal en vez de repetir el recálculo que falló.
          // Se avisa con un toast y quien repite la operación es el botón Recalcular, que el
          // .catch acaba de liberar.
          if (self.cargas.carga || self._periodoDatos === periodoPedido) {
            self.$f7.toast.create({
              text: 'No se ha podido recalcular el mes' + (detalle ? ': ' + detalle : '')
                + '. Lo que se ve son los datos de antes de recalcular; vuelve a pulsar Recalcular para reintentarlo.',
              position: 'top', closeTimeout: 4000
            }).open();
            return;
          }
          self.errorCarga = detalle || 'No se ha podido recalcular el mes.';
        });
    },
    guardarConfig: function() {
      var self = this;
      cerrojoDeLaSesion(self, 'guardando');
      self.configLocal.anio = self.anio;
      self.configLocal.mes = self.mes;
      self.configLocal.togglesGuardados = {};
      for (var t in self.toggles) { if (self.toggles.hasOwnProperty(t)) self.configLocal.togglesGuardados[t] = self.toggles[t]; }
      self.configLocal.togglesGuardados.redObjMen = self.redObjMen;
      // La lista de ocultos NO va aquí: es de cada usuario y se guarda persona a persona al
      // pulsar (ver cambiarOculta).
      Oeb.guardarConfigProductividadPlan(self.configLocal).then(function() {
        self.guardando = false;
        self.$f7.toast.create({ text: 'Guardado', position: 'top', closeTimeout: 2000 }).open();
        self.cargarDatos();
      }).catch(function(err) {
        // Guardar puede fallar también porque el servidor no haya podido tirar la caché del mes:
        // entonces la pantalla seguiría enseñando la cifra anterior. Callarlo dejaría a quien
        // guarda creyendo que su %Obj ya está puesto, que es el fallo del que viene esta tarea.
        self.guardando = false;
        var detalle = (err && err.responseJSON && err.responseJSON.message) || (err && err.message) || '';
        // Si se cortó sin respuesta, el servidor puede haber guardado igual. Decir "no se pudo
        // guardar" y quedarse con lo de antes en pantalla es peor que no decir nada: quien mira
        // vuelve a teclear el %Obj sobre unos datos que ya no son los guardados. La caché la tiró
        // Oeb.guardarConfigProductividadPlan; aquí se relee, que es la única forma de saber qué quedó.
        if (Oeb.esResultadoIncierto(err)) {
          self.$f7.toast.create({
            text: 'Guardar no ha respondido; se comprueba si llegó a aplicarse.',
            position: 'top', closeTimeout: 4000
          }).open();
          self.cargarDatos();
          return;
        }
        self.$f7.dialog.alert(detalle
          ? 'No se pudo guardar: ' + detalle
          : 'No se pudo guardar. Vuelve a intentarlo.', 'Error al guardar');
      });
    },
    getNombreMesSiguiente: function() {
      var meses = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
      var mesSig = this.mes === 12 ? 0 : this.mes;
      var anioSig = this.mes === 12 ? this.anio + 1 : this.anio;
      return meses[mesSig] + ' ' + anioSig;
    },
    crearMesSiguiente: function() {
      var self = this;
      if (self.creandoMes) return;
      var nombre = self.getNombreMesSiguiente();
      self.$f7.dialog.confirm('Se copiar\u00e1n planificadores, porcentajes y configuraci\u00f3n del mes actual a ' + nombre + '.', 'Crear ' + nombre, function() {
        self._ejecutarCrearMes(nombre, false);
      });
    },
    _ejecutarCrearMes: function(nombre, sobreescribir) {
      var self = this;
      cerrojoDeLaSesion(self, 'creandoMes');
      Oeb.crearMesSiguienteProductividadPlan({ anio: self.anio, mes: self.mes, sobreescribir: sobreescribir }).then(function(res) {
        self.creandoMes = false;
        if (res && unwrapDto(res) && unwrapDto(res).yaExiste) {
          self.$f7.dialog.confirm(unwrapDto(res).mensaje, 'Sobreescribir ' + nombre, function() {
            self._ejecutarCrearMes(nombre, true);
          });
        } else if (res && unwrapDto(res) && unwrapDto(res).anio && !unwrapDto(res).error) {
          var oebMsg = unwrapDto(res).oebMes ? self.fmtNum(unwrapDto(res).oebMes) + '\u20ac' : 'No disponible';
          if (self.mes === 12) { self.anio++; self.mes = 1; } else { self.mes++; }
          self.cargarDatos();
          self.$f7.dialog.alert(unwrapDto(res).mensaje || ('Configuraci\u00f3n creada. OEB: ' + oebMsg), nombre + ' creado');
        } else {
          var msg = 'Error desconocido';
          if (res && unwrapDto(res) && unwrapDto(res).error) msg = unwrapDto(res).error;
          else if (res && unwrapDto(res) && unwrapDto(res).mensaje) msg = unwrapDto(res).mensaje;
          self.$f7.dialog.alert(msg, 'Aviso');
        }
      }).catch(function() { self.creandoMes = false; self.$f7.dialog.alert('Error al crear mes', 'Error'); });
    },
    mesPrevio: function() { if (this.mes > 1) this.mes--; else { this.mes = 12; this.anio--; } this.cargarDatos(); },
    mesSiguiente: function() { if (this.mes < 12) this.mes++; else { this.mes = 1; this.anio++; } this.cargarDatos(); },
    getSemTotal: function(persona, sem) {
      if (!persona.porDia) return 0;
      var t = 0;
      for (var i = 0; i < sem.dias.length; i++) { t += (persona.porDia[sem.dias[i]] || 0); }
      return Math.round(t);
    },
    getSemTpcSi: function(persona, sem) {
      if (!persona.porDiaTpcSi) return 0;
      var t = 0;
      for (var i = 0; i < sem.dias.length; i++) { t += (persona.porDiaTpcSi[sem.dias[i]] || 0); }
      return Math.round(t);
    },
    getSemTpcNo: function(persona, sem) {
      if (!persona.porDiaTpcNo) return 0;
      var t = 0;
      for (var i = 0; i < sem.dias.length; i++) { t += (persona.porDiaTpcNo[sem.dias[i]] || 0); }
      return Math.round(t);
    },
    getSemPlanDia: function(persona, sem) {
      var total = this.getSemTotal(persona, sem);
      var drSem = this.getDiasSemPersona(persona, sem);
      return drSem > 0 ? Math.round(total / drSem) : 0;
    },
    getSemPpend: function(persona, sem) {
      if (!persona.porDiaPpend) return 0;
      var t = 0;
      for (var i = 0; i < sem.dias.length; i++) { t += (persona.porDiaPpend[sem.dias[i]] || 0); }
      return Math.round(t);
    },
    getTotalCampo: function(campo) {
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += (p[campo] || 0); });
      return Math.round(t * 10) / 10;
    },
    /**
     * Objetivo del mes de una persona: la suma de sus días, que es lo que suman sus semanas.
     *
     * Con RED.OBJ.MEN no es su %Obj del mes: quien absorbe la parte de un ausente tiene una meta
     * mayor y el ausente menor, y entre todos siguen sumando el OBJ. PLANIF. del mes. Sin el
     * toggle se calcula aquí a partir del %Obj para que al teclearlo se vea sin Guardar.
     */
    getObjetivoPersona: function(persona) {
      if (this.redObjMen) return persona.objetivoRed || 0;
      var pct = persona.porcentaje || 0;
      return Math.round((this.datos ? this.datos.objetivoTotal || 0 : 0) * pct);
    },
    // R-4: planificador con producción pero sin % asignado en config.
    // FALTA queda negativa y antes se pintaba en verde (apariencia "todo bien").
    // Ahora se destaca en ámbar para que destaque visualmente.
    sinObjetivoAsignado: function(persona) {
      return (!persona.porcentaje || persona.porcentaje === 0) && (persona.totalPlan || 0) > 0;
    },
    getFaltaPersona: function(persona) {
      return this.getObjetivoPersona(persona) - (persona.totalPlan || 0);
    },
    getPctPersona: function(persona) {
      var obj = this.getObjetivoPersona(persona);
      return obj > 0 ? Math.round((persona.totalPlan || 0) / obj * 1000) / 10 : 0;
    },
    getDiasSemPersona: function(persona, sem) {
      if (persona.diasRealesPorSemana && persona.diasRealesPorSemana[sem.semana] != null) {
        return persona.diasRealesPorSemana[sem.semana];
      }
      return sem.numDias;
    },
    /**
     * Objetivo de una persona en una semana: la suma de los días de esa semana que caen en este
     * mes, tal como los reparte la API. Los días en que falta alguien no valen lo mismo que el
     * resto, así que multiplicar el Obj/día por los días reales —lo que se hacía antes— no suma
     * ni el total de la fila ni el objetivo del mes (#13).
     */
    getObjSemPersona: function(persona, sem) {
      var porSemana = this.redObjMen ? persona.objetivoPorSemanaRed : persona.objetivoPorSemana;
      if (porSemana && porSemana[sem.semana] != null) return porSemana[sem.semana];
      // Datos de una versión anterior de la API, sin reparto por días: se reparte a ojo por días
      // del mes antes que dejar la celda vacía.
      var obj = this.getObjetivoPersona(persona);
      var totalDias = this.datos ? (this.datos.diasHabiles || 22) : 22;
      return Math.round(obj * (sem.numDias / totalDias));
    },
    getPctSem: function(sem) {
      if (!sem) return this.pctCumplimiento;
      var obj = this.getTotalObjSem(sem);
      var plan = this.getTotalSem(sem);
      return obj > 0 ? Math.round(plan / obj * 1000) / 10 : 0;
    },
    getPctSemClass: function(sem) {
      var pct = sem ? this.getPctSem(sem) : this.pctCumplimiento;
      if (pct > 100) return 'pct-excellent';
      if (pct >= 98) return 'pct-good';
      if (pct >= 94) return 'pct-warning';
      return 'pct-critical';
    },
    getTotalObjSem: function(sem) {
      var self = this;
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getObjSemPersona(p, sem); });
      return t;
    },
    setPctPersona: function(codigo, value) {
      var pct = parseInt(value) / 100;
      if (!this.configLocal.planificadores) this.configLocal.planificadores = [];
      var found = false;
      for (var i = 0; i < this.configLocal.planificadores.length; i++) {
        if (this.configLocal.planificadores[i].codigo === codigo) {
          this.configLocal.planificadores[i].porcentaje = pct;
          found = true;
          break;
        }
      }
      if (!found) this.configLocal.planificadores.push({ codigo: codigo, porcentaje: pct });
      // Update persona in datos
      if (this.datos && this.datos.personas) {
        for (var j = 0; j < this.datos.personas.length; j++) {
          if (this.datos.personas[j].codigo === codigo) {
            this.$set(this.datos.personas[j], 'porcentaje', pct);
            break;
          }
        }
      }
    },
    getSemPlanH: function(persona, sem) {
      var total = this.getSemTotal(persona, sem);
      var drSem = this.getDiasSemPersona(persona, sem);
      var horas = this.configLocal.horasPlanificacion || 7;
      var denominador = drSem * horas;
      return denominador > 0 ? Math.round(total / denominador) : 0;
    },
    getTotalSem: function(sem) {
      var self = this; var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getSemTotal(p, sem); });
      return t;
    },
    getTotalSemTpcSi: function(sem) {
      var self = this; var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getSemTpcSi(p, sem); });
      return t;
    },
    getTotalSemTpcNo: function(sem) {
      var self = this; var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getSemTpcNo(p, sem); });
      return t;
    },
    getTotalSemPlanDia: function(sem) {
      var total = this.getTotalSem(sem);
      var drTotal = 0;
      var self = this;
      this.personasFiltradas.forEach(function(p) { drTotal += self.getDiasSemPersona(p, sem); });
      return drTotal > 0 ? Math.round(total / drTotal) : 0;
    },
    getTotalSemPpend: function(sem) {
      var self = this; var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getSemPpend(p, sem); });
      return t;
    },
    getTotalSemPlanH: function(sem) {
      var total = 0;
      var drTotal = 0;
      var self = this;
      this.personasFiltradas.forEach(function(p) {
        total += self.getSemTotal(p, sem);
        drTotal += self.getDiasSemPersona(p, sem);
      });
      var horas = self.configLocal.horasPlanificacion || 7;
      var denominador = drTotal * horas;
      return denominador > 0 ? Math.round(total / denominador) : 0;
    },
    getCampoPanel: function(clave) {
      if (clave === 'ejecutor') return 'porEjecutor';
      if (clave === 'materia') return 'porMateria';
      if (clave === 'provincia') return 'porProvincia';
      return 'porContratacion';
    },
    // Los desgloses (porEjecutor/porContratacion/porMateria/porProvincia) llegan como
    // List<{k,v}> ya ordenada por v desc desde el backend, porque las claves pueden
    // contener puntos (materias "C.BAS", usernames "jose.cabrerizo") y Mongo no
    // permite puntos en nombres de campo al cachear el resultado.
    getCategorias: function(clave) {
      var cats = {};
      var campo = this.getCampoPanel(clave);
      this.personasFiltradas.forEach(function(p) {
        var data = p[campo];
        if (Array.isArray(data)) {
          data.forEach(function(e) { if (e && e.v > 0) cats[e.k] = (cats[e.k] || 0) + e.v; });
        }
      });
      return Object.keys(cats).sort(function(a, b) { return cats[b] - cats[a]; });
    },
    getValorPanel: function(persona, clave, cat) {
      var campo = this.getCampoPanel(clave);
      var data = persona[campo];
      if (!Array.isArray(data)) return 0;
      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].k === cat) return data[i].v || 0;
      }
      return 0;
    },
    getTotalCategoria: function(clave, cat) {
      var campo = this.getCampoPanel(clave);
      var t = 0;
      this.personasFiltradas.forEach(function(p) {
        var data = p[campo];
        if (!Array.isArray(data)) return;
        for (var i = 0; i < data.length; i++) {
          if (data[i] && data[i].k === cat) { t += data[i].v || 0; break; }
        }
      });
      return t;
    },
    getTotalPersonaPanel: function(persona, clave) {
      var campo = this.getCampoPanel(clave);
      var data = persona[campo];
      if (!Array.isArray(data)) return 0;
      var t = 0;
      for (var i = 0; i < data.length; i++) { if (data[i]) t += (data[i].v || 0); }
      return t;
    },
    getGranTotalPanel: function(clave) {
      var self = this;
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getTotalPersonaPanel(p, clave); });
      return t;
    },
    pctClase: function(pct) {
      if (pct >= 100) return 'pct-high';
      if (pct >= 80) return 'pct-mid';
      return 'pct-low';
    },
    abrirTooltipToggle: function(event, td) {
      if (this.tooltipToggle === td.clave) { this.tooltipToggle = null; return; }
      this.tooltipToggle = td.clave;
      var rect = event.target.getBoundingClientRect();
      this.tooltipTogglePos = { position: 'fixed', top: (rect.bottom + 8) + 'px', left: Math.max(10, rect.left - 100) + 'px', zIndex: 300 };
    },
    abrirTooltipKpi: function(event, nombre, desc) {
      if (this.tooltipKpiData && this.tooltipKpiData.nombre === nombre) { this.tooltipKpiData = null; return; }
      this.tooltipKpiData = { nombre: nombre, desc: desc };
      var rect = event.target.getBoundingClientRect();
      this.tooltipKpiPos = { position: 'fixed', top: (rect.bottom + 8) + 'px', left: Math.max(10, rect.left - 100) + 'px', zIndex: 300 };
    },
    cargarInstrucciones: function() {
      var self = this;
      Oeb.getInstrucciones('productividad-plan').then(function(res) {
        if (unwrapDto(res)) self.instrucciones = unwrapDto(res);
      });
    },
    guardarInstruccion: function(inst) {
      var self = this;
      if (inst.id) {
        Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto })
          .then(function() { self.$f7.toast.create({ text: 'Guardado', position: 'top', closeTimeout: 1500 }).open(); });
      } else {
        inst.pantalla = 'productividad-plan';
        inst.orden = self.instrucciones.length;
        Oeb.crearInstruccion(inst)
          .then(function(res) { if (unwrapDto(res) && unwrapDto(res).id) inst.id = unwrapDto(res).id; self.$f7.toast.create({ text: 'Creado', position: 'top', closeTimeout: 1500 }).open(); });
      }
    },
    nuevaInstruccion: function() {
      var inst = { titulo: 'Nuevo apartado', texto: '', pantalla: 'productividad-plan', orden: this.instrucciones.length };
      this.instrucciones.push(inst);
      this.expandedInst = this.instrucciones.length - 1;
    },
    eliminarInstruccion: function(inst) {
      var self = this;
      self.$f7.dialog.confirm('Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        if (inst.id) {
          Oeb.eliminarInstruccion(inst.id).then(function() { self.cargarInstrucciones(); });
        } else {
          var idx = self.instrucciones.indexOf(inst);
          if (idx > -1) self.instrucciones.splice(idx, 1);
        }
      });
    },
    moverInstruccion: function(inst, dir) {
      var idx = this.instrucciones.indexOf(inst);
      var newIdx = idx + dir;
      if (newIdx < 0 || newIdx >= this.instrucciones.length) return;
      var arr = this.instrucciones.slice();
      arr.splice(idx, 1);
      arr.splice(newIdx, 0, inst);
      this.instrucciones = arr;
      var ids = arr.filter(function(i) { return i.id; }).map(function(i) { return i.id; });
      if (ids.length > 0) Oeb.reordenarInstrucciones(ids);
    },
    abrirPopupReporte: function() {
      var self = this;
      self.reporteTipo = 'MENSUAL';
      self.cambiarTipoReporte('MENSUAL');
      Oeb.getPersonasConfig().then(function(res) {
        var personas = (unwrapDto(res) || []);
        var emails = personas.filter(function(p) { return p.email && p.activo; }).map(function(p) { return p.email; });
        self.reporteEmails = emails.join(', ');
        self.popupReporte = true;
      }).catch(function() { self.popupReporte = true; });
    },
    cambiarTipoReporte: function(tipo) {
      this.reporteTipo = tipo;
      var label = tipo === 'DIARIO' ? 'Informe diario' : tipo === 'SEMANAL' ? 'Informe semanal' : 'Informe mensual';
      var meses = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      this.reporteAsunto = label + ' Productividad Planificaci\u00f3n \u2014 SIMECAL \u2014 ' + meses[this.mes] + ' ' + this.anio;
    },
    confirmarEnvioReporte: function() {
      var self = this;
      var emails = self.reporteEmails.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; });
      if (!emails.length) {
        self.$f7.toast.create({ text: 'Introduce al menos un email', position: 'top', closeTimeout: 2000 }).open();
        return;
      }
      var emailsCc = self.reporteCc ? self.reporteCc.split(',').map(function(e) { return e.trim(); }).filter(function(e) { return e; }) : [];
      cerrojoDeLaSesion(self, 'enviandoReporte');
      Oeb.enviarReporteProductividadPlan({
        anio: self.anio, mes: self.mes,
        emails: emails, emailsCc: emailsCc, emailsCco: [],
        asunto: self.reporteAsunto, tipoReporte: self.reporteTipo,
        personasCodigos: self.personasFiltradas.map(function(p) { return p.codigo; })
      }).then(function(res) {
        self.enviandoReporte = false;
        self.popupReporte = false;
        self.$f7.toast.create({ text: unwrapDto(res) || 'Reporte enviado', position: 'top', closeTimeout: 3000 }).open();
      }).catch(function() {
        self.enviandoReporte = false;
        self.$f7.toast.create({ text: 'Error al enviar reporte', position: 'top', closeTimeout: 3000 }).open();
      });
    },
    getImporteDiaPersona: function(persona, dia) {
      if (!persona.porDia) return 0;
      return persona.porDia[String(dia)] || 0;
    },
    /**
     * Obj/día de una persona: lo que le toca un día normal, uno en el que no falta nadie. Es el
     * número que enseña Planificación Diaria esos días.
     *
     * Con la regla de la #13 el objetivo diario ya no es constante a lo largo del mes: los días en
     * que falta alguien, los que trabajan llevan además su parte. Eso se ve día a día en
     * "Planificación diaria por persona", no en esta columna.
     */
    getObjDiaBase: function(persona) {
      return (this.redObjMen ? persona.objDiaRed : persona.objDia) || 0;
    },
    /**
     * Objetivo de una persona para UN día: 0 si ese día no trabaja y, con RED.OBJ.MEN, con la parte
     * de quien falta ese día ya sumada. Sale tal cual de la API, que es la misma cuenta y el mismo
     * número que enseña Planificación Diaria para ese día.
     */
    getObjDiaPersonaDia: function(persona, dia) {
      var porDia = this.redObjMen ? persona.objDiaPorDiaRed : persona.objDiaPorDia;
      if (porDia && porDia[String(dia)] != null) return porDia[String(dia)];
      // Datos de una versión anterior de la API, sin reparto por días.
      return this.esAusenciaPersonaDia(persona, dia) ? 0 : this.getObjDiaBase(persona);
    },
    esAusenciaPersonaDia: function(persona, dia) {
      return persona.ausenciasPorDia && persona.ausenciasPorDia[String(dia)] != null;
    },
    getLetraAusencia: function(tipo) {
      if (tipo === 'vac') return 'V';
      if (tipo === 'bl') return 'B';
      if (tipo === 'fiesta') return 'F';
      if (tipo === 'comp') return 'C';
      return '?';
    },
    getCeldaPlanClass: function(persona, dia) {
      // Sin objetivo fiable no hay contra qué comparar: la celda se queda sin color en vez de
      // pintar de verde o rojo un cumplimiento que no significa nada.
      if (!this.objetivoFiable) return '';
      if (this.esAusenciaPersonaDia(persona, dia)) return '';
      var importe = this.getImporteDiaPersona(persona, dia);
      if (importe <= 0) return '';
      var objDia = this.getObjDiaPersonaDia(persona, dia);
      if (objDia <= 0) return '';
      var pct = (importe / objDia) * 100;
      if (pct > 100) return 'celda-excellent';
      if (pct >= 98) return 'celda-good';
      if (pct >= 94) return 'celda-warning';
      return 'celda-critical';
    },
    getTotalDiaPersonas: function(dia) {
      var t = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.porDia && p.porDia[String(dia)]) t += p.porDia[String(dia)];
      });
      return t;
    },
    getTotalObjDiaTodas: function(dia) {
      var self = this;
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += self.getObjDiaPersonaDia(p, dia); });
      return t;
    },
    getTotalPlanificadoPersonas: function() {
      var t = 0;
      this.personasFiltradas.forEach(function(p) { t += (p.totalPlan || 0); });
      return t;
    },
    getCeldaTotalClass: function(dia) {
      if (!this.objetivoFiable) return '';
      var total = this.getTotalDiaPersonas(dia);
      if (total <= 0) return '';
      var obj = this.getTotalObjDiaTodas(dia);
      if (obj <= 0) return '';
      var pct = (total / obj) * 100;
      if (pct > 100) return 'celda-excellent';
      if (pct >= 98) return 'celda-good';
      if (pct >= 94) return 'celda-warning';
      return 'celda-critical';
    },
    getHeaderDiaStyle: function(d) {
      var s = '';
      if (this.esHoy(d.dia)) s += 'background:#E3F2FD;';
      if (this.esViernes(d.diaSemana)) s += 'border-right:2px solid #aaa;';
      return s;
    },
    getCeldaDiaStyle: function(d) {
      var s = '';
      if (this.esHoy(d.dia)) s += 'background:#E3F2FD;';
      if (this.esViernes(d.diaSemana)) s += 'border-right:2px solid #aaa;';
      return s;
    },
    fmtNumCorto: function(v) {
      if (v == null || v === 0) return '0';
      if (Math.abs(v) >= 1000) {
        var k = Math.round(v / 100) / 10;
        return k.toLocaleString('es-ES', {minimumFractionDigits: 0, maximumFractionDigits: 1}) + 'k';
      }
      return Math.round(v).toLocaleString('es-ES');
    },
    esHoy: function(dia) {
      if (!this.datos) return false;
      var hoy = new Date();
      return hoy.getFullYear() === this.datos.anio && (hoy.getMonth() + 1) === this.datos.mes && hoy.getDate() === dia;
    },
    esViernes: function(diaSemana) {
      return diaSemana === 'V';
    },
    esSemanaFutura: function(sem) {
      if (!this.datos || !sem.dias || sem.dias.length === 0) return true;
      var primerDiaSem = new Date(this.datos.anio, this.datos.mes - 1, sem.dias[0]);
      return primerDiaSem > new Date();
    },
    esDiaFestivo: function(dia) {
      var total = this.personasFiltradas.length;
      if (total === 0) return false;
      var count = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.ausenciasPorDia && p.ausenciasPorDia[String(dia)] === 'fiesta') count++;
      });
      return count === total;
    },
    getTotalPlanDia: function(dia) {
      var t = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.porDia && p.porDia[String(dia)]) t += p.porDia[String(dia)];
      });
      return t;
    },
    getTotalObjDia: function(dia) {
      return this.getTotalObjDiaTodas(dia);
    },
    getPctAcumDia: function(sem, idx) {
      var planAcum = 0, objAcum = 0;
      for (var i = 0; i <= idx; i++) {
        if (i >= sem.dias.length) break;
        var dia = sem.dias[i];
        if (this.esDiaFestivo(dia)) continue;
        planAcum += this.getTotalPlanDia(dia);
        objAcum += this.getTotalObjDia(dia);
      }
      return objAcum > 0 ? Math.round(planAcum / objAcum * 100) : 0;
    },
    getPctAcumSemana: function(sem) {
      if (!sem.dias || sem.dias.length === 0) return 0;
      return this.getPctAcumDia(sem, sem.dias.length - 1);
    },
    getPctDiaClass: function(pct) {
      if (pct > 100) return 'badge-pct-sem pct-excellent';
      if (pct >= 98) return 'badge-pct-sem pct-good';
      if (pct >= 94) return 'badge-pct-sem pct-warning';
      return 'badge-pct-sem pct-critical';
    },
    getFilaDiaStyle: function(d, idx) {
      var s = '';
      if (idx > 0 && this.datos && this.datos.registroProgresivo) {
        var prev = this.datos.registroProgresivo.dias[idx - 1];
        if (prev && d.semana !== prev.semana && d.mes === prev.mes) s += 'border-top:2px solid #ccc;';
      }
      if (d.mes % 2 === 0) s += 'background:#fafafa;';
      return s;
    },
    getClaseRegistro: function(pct, diaIdx) {
      if (pct == null || pct === 0) return '';
      var bases = [50, 60, 70, 80, 90];
      var base = bases[diaIdx] || 50;
      if (pct > base + 10) return 'reg-azul';
      if (pct >= base + 10) return 'reg-verde';
      if (pct >= base + 5) return 'reg-amarillo';
      if (pct >= base) return 'reg-rojo-suave';
      return 'reg-rojo-fuerte';
    },
    /**
     * El registro recorre el año entero, así que la fiabilidad va por fila y no por pantalla:
     * objetivoFiable solo habla del mes abierto, y el objetivo de los demás meses sale de su ficha
     * mensual, que no deja de conocerse porque el cálculo del mes abierto falle. La API lo dice
     * fila a fila; objetivoFiable queda como respaldo mientras no esté desplegada.
     *
     * Cada fila se mide contra el objetivo de la semana SIGUIENTE, que puede caer en el mes
     * siguiente: por eso el flag de la fila no es el de su propio mes.
     */
    regObjSigFiable: function(d) {
      if (typeof d.objetivoSiguienteFiable === 'boolean') return d.objetivoSiguienteFiable;
      return this.objetivoFiable;
    },
    /** Igual, para el trozo de semana partida que cuenta contra el mes de la propia fila. */
    regObjRestoFiable: function(d) {
      if (typeof d.objetivoRestoFiable === 'boolean') return d.objetivoRestoFiable;
      return this.objetivoFiable;
    },
    /**
     * Cumplimiento del trozo de semana partida. Las columnas L-V de esta fila miden la semana
     * SIGUIENTE, así que este porcentaje no cabe en ellas y se enseña junto a su objetivo. La API lo
     * cierra con lo confirmado antes de que empezara la semana —la misma ventana con la que el
     * viernes anterior cierra el otro trozo—, de ahí que se coloree con el umbral del viernes y no
     * con el del día de la fila. Respuestas anteriores a este campo no lo traen: entonces no se
     * enseña nada, como hasta ahora.
     */
    regPctRestoTxt: function(d) {
      if (!this.regObjRestoFiable(d) || d.porcentajeResto == null) return null;
      return Math.round(d.porcentajeResto) + '%';
    },
    regPctRestoClase: function(d) {
      if (!this.regObjRestoFiable(d) || d.porcentajeResto == null) return '';
      return this.getClaseRegistro(d.porcentajeResto, 4);
    },
    /**
     * El porcentaje del registro progresivo es confirmado/objetivo de la semana siguiente, así que
     * sin objetivo fiable no hay contra qué comparar: la celda se queda sin color en vez de pintar
     * de rojo o de verde un cumplimiento que no significa nada.
     */
    getClaseRegistroCelda: function(d, colIdx) {
      if (!this.regObjSigFiable(d)) return '';
      if (d.diaIdx !== colIdx || !(d.porcentaje > 0)) return '';
      return this.getClaseRegistro(d.porcentaje, colIdx);
    },
    /**
     * Qué enseña la celda del día, o null para el guion de «ese día no toca». Sin objetivo fiable el
     * porcentaje llega a 0 y el guion se confundiría con no haber confirmado nada: mientras haya
     * confirmado se dice n/d, que es lo que de verdad pasa.
     */
    regPctTxt: function(d, colIdx) {
      if (d.diaIdx !== colIdx) return null;
      if (!this.regObjSigFiable(d)) return d.importeAcum > 0 ? 'n/d' : null;
      return d.porcentaje > 0 ? Math.round(d.porcentaje) + '%' : null;
    },
    fmtNum: function(v) {
      if (v == null || v === 0) return '0';
      if (Math.abs(v) >= 1000) return Math.round(v).toLocaleString('es-ES');
      return Math.round(v).toString();
    },
    /** Importe que depende del objetivo del mes: n/d mientras el objetivo no sea fiable. */
    fmtObj: function(v) {
      return this.objetivoFiable ? this.fmtNum(v) : 'n/d';
    },
    /** Porcentaje de cumplimiento: n/d mientras el objetivo no sea fiable. */
    fmtPctObj: function(pct) {
      return this.objetivoFiable ? pct + '%' : 'n/d';
    },
    tStyle: function(color, active) {
      if (active) return { background: color, color: '#fff', border: '1px solid ' + color };
      return { background: '#f0f2f5', color: '#666', border: '1px solid #ddd' };
    },
    zoomIn: function() { if (this.zoom < 150) this.zoom += 10; },
    zoomOut: function() { if (this.zoom > 50) this.zoom -= 10; }
  }
};
</script>
